/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, FileData, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from './request'
// @ts-ignore
import makeRequestHook from './makeRequestHook'

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult
> = (TRequestConfig['requestDataOptional'] extends true
  ? (
      requestData?: TRequestData,
      ...args: RequestFunctionRestArgs<typeof request>
    ) => TRequestResult
  : (
      requestData: TRequestData,
      ...args: RequestFunctionRestArgs<typeof request>
    ) => TRequestResult) & {
  requestConfig: TRequestConfig
}

const mockUrl_0_0_0_1 = 'http://10.19.12.152:8989/mock/502' as any
const devUrl_0_0_0_1 = '' as any
const prodUrl_0_0_0_1 = '' as any
const dataKey_0_0_0_1 = 'data' as any

/**
 * 接口 [权限-获取用户信息↗](http://10.19.12.152:8989/project/502/interface/api/29245) 的 **请求类型**
 *
 * @分类 [首页/权限↗](http://10.19.12.152:8989/project/502/interface/api/cat_4223)
 * @请求头 `GET /api/app/auth/userInfo`
 * @更新时间 `2025-09-15 15:01:11`
 */
export interface ApiGetAuthUserInfoRequest {}

/**
 * 接口 [权限-获取用户信息↗](http://10.19.12.152:8989/project/502/interface/api/29245) 的 **返回类型**
 *
 * @分类 [首页/权限↗](http://10.19.12.152:8989/project/502/interface/api/cat_4223)
 * @请求头 `GET /api/app/auth/userInfo`
 * @更新时间 `2025-09-15 15:01:11`
 */
export interface ApiGetAuthUserInfoResponse {
  /**
   * 工号
   */
  workNumber: number
  /**
   * 姓名
   */
  userName: string
  /**
   * 邮箱
   */
  email: string
  /**
   * 部门
   */
  department: string
  /**
   * 手机号
   */
  mobile: number
  /**
   * 座机号码
   */
  phone: number
  /**
   * 微信状态 0 未绑定 1 已绑定
   */
  wxStatus: number
  perms: {
    /**
     * panther ; domeos
     */
    module: string
    hasAuth: boolean
  }[]
}

/**
 * 接口 [权限-获取用户信息↗](http://10.19.12.152:8989/project/502/interface/api/29245) 的 **请求配置的类型**
 *
 * @分类 [首页/权限↗](http://10.19.12.152:8989/project/502/interface/api/cat_4223)
 * @请求头 `GET /api/app/auth/userInfo`
 * @更新时间 `2025-09-15 15:01:11`
 */
type ApiGetAuthUserInfoRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/auth/userInfo',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [权限-获取用户信息↗](http://10.19.12.152:8989/project/502/interface/api/29245) 的 **请求配置**
 *
 * @分类 [首页/权限↗](http://10.19.12.152:8989/project/502/interface/api/cat_4223)
 * @请求头 `GET /api/app/auth/userInfo`
 * @更新时间 `2025-09-15 15:01:11`
 */
const apiGetAuthUserInfoRequestConfig: ApiGetAuthUserInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: '/api/app/auth/userInfo',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetAuthUserInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [权限-获取用户信息↗](http://10.19.12.152:8989/project/502/interface/api/29245) 的 **请求函数**
 *
 * @分类 [首页/权限↗](http://10.19.12.152:8989/project/502/interface/api/cat_4223)
 * @请求头 `GET /api/app/auth/userInfo`
 * @更新时间 `2025-09-15 15:01:11`
 */
const apiGetAuthUserInfo = /*#__PURE__*/ (
  requestData?: ApiGetAuthUserInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetAuthUserInfoResponse>(
    prepare(apiGetAuthUserInfoRequestConfig, requestData),
    ...args
  )
}

apiGetAuthUserInfo.requestConfig = apiGetAuthUserInfoRequestConfig

/**
 * 接口 [权限-获取用户信息↗](http://10.19.12.152:8989/project/502/interface/api/29245) 的 **React Hook**
 *
 * @分类 [首页/权限↗](http://10.19.12.152:8989/project/502/interface/api/cat_4223)
 * @请求头 `GET /api/app/auth/userInfo`
 * @更新时间 `2025-09-15 15:01:11`
 */
export const useApiGetAuthUserInfo = /*#__PURE__*/ makeRequestHook<
  ApiGetAuthUserInfoRequest,
  ApiGetAuthUserInfoRequestConfig,
  ReturnType<typeof apiGetAuthUserInfo>
>(apiGetAuthUserInfo)

/**
 * 接口 [首页-模块概览↗](http://10.19.12.152:8989/project/502/interface/api/29252) 的 **请求类型**
 *
 * @分类 [首页/权限↗](http://10.19.12.152:8989/project/502/interface/api/cat_4223)
 * @请求头 `GET /api/app/auth/module/overview`
 * @更新时间 `2026-01-20 18:27:55`
 */
export interface ApiGetAuthModuleOverviewRequest {}

/**
 * 接口 [首页-模块概览↗](http://10.19.12.152:8989/project/502/interface/api/29252) 的 **返回类型**
 *
 * @分类 [首页/权限↗](http://10.19.12.152:8989/project/502/interface/api/cat_4223)
 * @请求头 `GET /api/app/auth/module/overview`
 * @更新时间 `2026-01-20 18:27:55`
 */
export interface ApiGetAuthModuleOverviewResponse {
  /**
   * domeos服务数
   */
  domeosService: number
  /**
   * domeos部署数
   */
  domeosDeploy: number
  /**
   * doemos资源包数
   */
  domeosPackage: number
  /**
   * domeos项目数
   */
  domeosProject: number
  /**
   * domeos工程数
   */
  domeosEngineer: number
  /**
   * domeos异常数
   */
  domeosException: number
  /**
   * domeos未恢复异常数
   */
  domeosUnException: number
  /**
   * redis未恢复告警数
   */
  redisUnException: number
  /**
   * redis实例数量
   */
  redisInstCount: number
}

/**
 * 接口 [首页-模块概览↗](http://10.19.12.152:8989/project/502/interface/api/29252) 的 **请求配置的类型**
 *
 * @分类 [首页/权限↗](http://10.19.12.152:8989/project/502/interface/api/cat_4223)
 * @请求头 `GET /api/app/auth/module/overview`
 * @更新时间 `2026-01-20 18:27:55`
 */
type ApiGetAuthModuleOverviewRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/auth/module/overview',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [首页-模块概览↗](http://10.19.12.152:8989/project/502/interface/api/29252) 的 **请求配置**
 *
 * @分类 [首页/权限↗](http://10.19.12.152:8989/project/502/interface/api/cat_4223)
 * @请求头 `GET /api/app/auth/module/overview`
 * @更新时间 `2026-01-20 18:27:55`
 */
const apiGetAuthModuleOverviewRequestConfig: ApiGetAuthModuleOverviewRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: '/api/app/auth/module/overview',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetAuthModuleOverview',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [首页-模块概览↗](http://10.19.12.152:8989/project/502/interface/api/29252) 的 **请求函数**
 *
 * @分类 [首页/权限↗](http://10.19.12.152:8989/project/502/interface/api/cat_4223)
 * @请求头 `GET /api/app/auth/module/overview`
 * @更新时间 `2026-01-20 18:27:55`
 */
const apiGetAuthModuleOverview = /*#__PURE__*/ (
  requestData?: ApiGetAuthModuleOverviewRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetAuthModuleOverviewResponse>(
    prepare(apiGetAuthModuleOverviewRequestConfig, requestData),
    ...args
  )
}

apiGetAuthModuleOverview.requestConfig = apiGetAuthModuleOverviewRequestConfig

/**
 * 接口 [首页-模块概览↗](http://10.19.12.152:8989/project/502/interface/api/29252) 的 **React Hook**
 *
 * @分类 [首页/权限↗](http://10.19.12.152:8989/project/502/interface/api/cat_4223)
 * @请求头 `GET /api/app/auth/module/overview`
 * @更新时间 `2026-01-20 18:27:55`
 */
export const useApiGetAuthModuleOverview = /*#__PURE__*/ makeRequestHook<
  ApiGetAuthModuleOverviewRequest,
  ApiGetAuthModuleOverviewRequestConfig,
  ReturnType<typeof apiGetAuthModuleOverview>
>(apiGetAuthModuleOverview)

/**
 * 接口 [首页-平台值班↗](http://10.19.12.152:8989/project/502/interface/api/29259) 的 **请求类型**
 *
 * @分类 [首页/权限↗](http://10.19.12.152:8989/project/502/interface/api/cat_4223)
 * @请求头 `GET /api/app/auth/duty`
 * @更新时间 `2025-08-08 17:06:45`
 */
export interface ApiGetAuthDutyRequest {}

/**
 * 接口 [首页-平台值班↗](http://10.19.12.152:8989/project/502/interface/api/29259) 的 **返回类型**
 *
 * @分类 [首页/权限↗](http://10.19.12.152:8989/project/502/interface/api/cat_4223)
 * @请求头 `GET /api/app/auth/duty`
 * @更新时间 `2025-08-08 17:06:45`
 */
export interface ApiGetAuthDutyResponse {
  leader: {
    id: number
    /**
     * 姓名
     */
    username: string
    orderNum: number
    /**
     * 模块
     */
    type: string
    /**
     * 手机号码
     */
    mobile: string
    /**
     * 座机号码
     */
    phone: string
    /**
     * 邮箱
     */
    email: string
    status: number
    createTime: number
    updateTime: number
    workNumber: number
  }[]
}

/**
 * 接口 [首页-平台值班↗](http://10.19.12.152:8989/project/502/interface/api/29259) 的 **请求配置的类型**
 *
 * @分类 [首页/权限↗](http://10.19.12.152:8989/project/502/interface/api/cat_4223)
 * @请求头 `GET /api/app/auth/duty`
 * @更新时间 `2025-08-08 17:06:45`
 */
type ApiGetAuthDutyRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/auth/duty',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [首页-平台值班↗](http://10.19.12.152:8989/project/502/interface/api/29259) 的 **请求配置**
 *
 * @分类 [首页/权限↗](http://10.19.12.152:8989/project/502/interface/api/cat_4223)
 * @请求头 `GET /api/app/auth/duty`
 * @更新时间 `2025-08-08 17:06:45`
 */
const apiGetAuthDutyRequestConfig: ApiGetAuthDutyRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: '/api/app/auth/duty',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiGetAuthDuty',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {}
}

/**
 * 接口 [首页-平台值班↗](http://10.19.12.152:8989/project/502/interface/api/29259) 的 **请求函数**
 *
 * @分类 [首页/权限↗](http://10.19.12.152:8989/project/502/interface/api/cat_4223)
 * @请求头 `GET /api/app/auth/duty`
 * @更新时间 `2025-08-08 17:06:45`
 */
const apiGetAuthDuty = /*#__PURE__*/ (
  requestData?: ApiGetAuthDutyRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetAuthDutyResponse>(
    prepare(apiGetAuthDutyRequestConfig, requestData),
    ...args
  )
}

apiGetAuthDuty.requestConfig = apiGetAuthDutyRequestConfig

/**
 * 接口 [首页-平台值班↗](http://10.19.12.152:8989/project/502/interface/api/29259) 的 **React Hook**
 *
 * @分类 [首页/权限↗](http://10.19.12.152:8989/project/502/interface/api/cat_4223)
 * @请求头 `GET /api/app/auth/duty`
 * @更新时间 `2025-08-08 17:06:45`
 */
export const useApiGetAuthDuty = /*#__PURE__*/ makeRequestHook<
  ApiGetAuthDutyRequest,
  ApiGetAuthDutyRequestConfig,
  ReturnType<typeof apiGetAuthDuty>
>(apiGetAuthDuty)

/**
 * 接口 [首页-平台公告↗](http://10.19.12.152:8989/project/502/interface/api/29266) 的 **请求类型**
 *
 * @分类 [首页/权限↗](http://10.19.12.152:8989/project/502/interface/api/cat_4223)
 * @请求头 `GET /api/app/auth/notice`
 * @更新时间 `2025-08-08 16:04:42`
 */
export interface ApiGetAuthNoticeRequest {
  /**
   * 固定为2
   */
  length: string
  /**
   * 固定为0
   */
  start: string
}

/**
 * 接口 [首页-平台公告↗](http://10.19.12.152:8989/project/502/interface/api/29266) 的 **返回类型**
 *
 * @分类 [首页/权限↗](http://10.19.12.152:8989/project/502/interface/api/cat_4223)
 * @请求头 `GET /api/app/auth/notice`
 * @更新时间 `2025-08-08 16:04:42`
 */
export interface ApiGetAuthNoticeResponse {
  datas: {
    id: number
    /**
     * 发布时间
     */
    time: number
    type: string
    /**
     * 公告标题
     */
    title: string
    status: number
  }[]
  /**
   * 总数  固定为2
   */
  totalCount: number
}

/**
 * 接口 [首页-平台公告↗](http://10.19.12.152:8989/project/502/interface/api/29266) 的 **请求配置的类型**
 *
 * @分类 [首页/权限↗](http://10.19.12.152:8989/project/502/interface/api/cat_4223)
 * @请求头 `GET /api/app/auth/notice`
 * @更新时间 `2025-08-08 16:04:42`
 */
type ApiGetAuthNoticeRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/auth/notice',
    'data',
    string,
    'length' | 'start',
    false
  >
>

/**
 * 接口 [首页-平台公告↗](http://10.19.12.152:8989/project/502/interface/api/29266) 的 **请求配置**
 *
 * @分类 [首页/权限↗](http://10.19.12.152:8989/project/502/interface/api/cat_4223)
 * @请求头 `GET /api/app/auth/notice`
 * @更新时间 `2025-08-08 16:04:42`
 */
const apiGetAuthNoticeRequestConfig: ApiGetAuthNoticeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: '/api/app/auth/notice',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: ['length', 'start'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetAuthNotice',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [首页-平台公告↗](http://10.19.12.152:8989/project/502/interface/api/29266) 的 **请求函数**
 *
 * @分类 [首页/权限↗](http://10.19.12.152:8989/project/502/interface/api/cat_4223)
 * @请求头 `GET /api/app/auth/notice`
 * @更新时间 `2025-08-08 16:04:42`
 */
const apiGetAuthNotice = /*#__PURE__*/ (
  requestData: ApiGetAuthNoticeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetAuthNoticeResponse>(
    prepare(apiGetAuthNoticeRequestConfig, requestData),
    ...args
  )
}

apiGetAuthNotice.requestConfig = apiGetAuthNoticeRequestConfig

/**
 * 接口 [首页-平台公告↗](http://10.19.12.152:8989/project/502/interface/api/29266) 的 **React Hook**
 *
 * @分类 [首页/权限↗](http://10.19.12.152:8989/project/502/interface/api/cat_4223)
 * @请求头 `GET /api/app/auth/notice`
 * @更新时间 `2025-08-08 16:04:42`
 */
export const useApiGetAuthNotice = /*#__PURE__*/ makeRequestHook<
  ApiGetAuthNoticeRequest,
  ApiGetAuthNoticeRequestConfig,
  ReturnType<typeof apiGetAuthNotice>
>(apiGetAuthNotice)

/**
 * 接口 [获取公告详情↗](http://10.19.12.152:8989/project/502/interface/api/29315) 的 **请求类型**
 *
 * @分类 [首页/权限↗](http://10.19.12.152:8989/project/502/interface/api/cat_4223)
 * @请求头 `GET /api/app/auth/notice/:id`
 * @更新时间 `2025-08-22 18:17:07`
 */
export interface ApiGetAuthNoticeIdRequest {
  id: string
}

/**
 * 接口 [获取公告详情↗](http://10.19.12.152:8989/project/502/interface/api/29315) 的 **返回类型**
 *
 * @分类 [首页/权限↗](http://10.19.12.152:8989/project/502/interface/api/cat_4223)
 * @请求头 `GET /api/app/auth/notice/:id`
 * @更新时间 `2025-08-22 18:17:07`
 */
export interface ApiGetAuthNoticeIdResponse {
  /**
   * 公告内容
   */
  content: string
  /**
   * 公告标题
   */
  title: string
}

/**
 * 接口 [获取公告详情↗](http://10.19.12.152:8989/project/502/interface/api/29315) 的 **请求配置的类型**
 *
 * @分类 [首页/权限↗](http://10.19.12.152:8989/project/502/interface/api/cat_4223)
 * @请求头 `GET /api/app/auth/notice/:id`
 * @更新时间 `2025-08-22 18:17:07`
 */
type ApiGetAuthNoticeIdRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/auth/notice/:id',
    'data',
    'id',
    string,
    false
  >
>

/**
 * 接口 [获取公告详情↗](http://10.19.12.152:8989/project/502/interface/api/29315) 的 **请求配置**
 *
 * @分类 [首页/权限↗](http://10.19.12.152:8989/project/502/interface/api/cat_4223)
 * @请求头 `GET /api/app/auth/notice/:id`
 * @更新时间 `2025-08-22 18:17:07`
 */
const apiGetAuthNoticeIdRequestConfig: ApiGetAuthNoticeIdRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: '/api/app/auth/notice/:id',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: ['id'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetAuthNoticeId',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [获取公告详情↗](http://10.19.12.152:8989/project/502/interface/api/29315) 的 **请求函数**
 *
 * @分类 [首页/权限↗](http://10.19.12.152:8989/project/502/interface/api/cat_4223)
 * @请求头 `GET /api/app/auth/notice/:id`
 * @更新时间 `2025-08-22 18:17:07`
 */
const apiGetAuthNoticeId = /*#__PURE__*/ (
  requestData: ApiGetAuthNoticeIdRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetAuthNoticeIdResponse>(
    prepare(apiGetAuthNoticeIdRequestConfig, requestData),
    ...args
  )
}

apiGetAuthNoticeId.requestConfig = apiGetAuthNoticeIdRequestConfig

/**
 * 接口 [获取公告详情↗](http://10.19.12.152:8989/project/502/interface/api/29315) 的 **React Hook**
 *
 * @分类 [首页/权限↗](http://10.19.12.152:8989/project/502/interface/api/cat_4223)
 * @请求头 `GET /api/app/auth/notice/:id`
 * @更新时间 `2025-08-22 18:17:07`
 */
export const useApiGetAuthNoticeId = /*#__PURE__*/ makeRequestHook<
  ApiGetAuthNoticeIdRequest,
  ApiGetAuthNoticeIdRequestConfig,
  ReturnType<typeof apiGetAuthNoticeId>
>(apiGetAuthNoticeId)

const mockUrl_0_0_0_2 = 'http://10.19.12.152:8989/mock/502' as any
const devUrl_0_0_0_2 = '' as any
const prodUrl_0_0_0_2 = '' as any
const dataKey_0_0_0_2 = 'data' as any

/**
 * 接口 [概览-我的资源↗](http://10.19.12.152:8989/project/502/interface/api/29273) 的 **请求类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/overview/resource`
 * @更新时间 `2026-01-15 17:24:14`
 */
export interface ApiGetDomeosOverviewResourceRequest {}

/**
 * 接口 [概览-我的资源↗](http://10.19.12.152:8989/project/502/interface/api/29273) 的 **返回类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/overview/resource`
 * @更新时间 `2026-01-15 17:24:14`
 */
export interface ApiGetDomeosOverviewResourceResponse {
  /**
   * 服务数量
   */
  serviceNum: number
  /**
   * 部署数量
   */
  deploymentNum: number
  /**
   * 资源包数量
   */
  bundleNum: number
  /**
   * 负载均衡数量
   */
  loadBalancerNum: number
  /**
   * 项目数量
   */
  projectCollectionNum: number
  /**
   * 工程数量
   */
  projectNum: number
}

/**
 * 接口 [概览-我的资源↗](http://10.19.12.152:8989/project/502/interface/api/29273) 的 **请求配置的类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/overview/resource`
 * @更新时间 `2026-01-15 17:24:14`
 */
type ApiGetDomeosOverviewResourceRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/domeos/overview/resource',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [概览-我的资源↗](http://10.19.12.152:8989/project/502/interface/api/29273) 的 **请求配置**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/overview/resource`
 * @更新时间 `2026-01-15 17:24:14`
 */
const apiGetDomeosOverviewResourceRequestConfig: ApiGetDomeosOverviewResourceRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/api/app/domeos/overview/resource',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetDomeosOverviewResource',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [概览-我的资源↗](http://10.19.12.152:8989/project/502/interface/api/29273) 的 **请求函数**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/overview/resource`
 * @更新时间 `2026-01-15 17:24:14`
 */
const apiGetDomeosOverviewResource = /*#__PURE__*/ (
  requestData?: ApiGetDomeosOverviewResourceRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetDomeosOverviewResourceResponse>(
    prepare(apiGetDomeosOverviewResourceRequestConfig, requestData),
    ...args
  )
}

apiGetDomeosOverviewResource.requestConfig =
  apiGetDomeosOverviewResourceRequestConfig

/**
 * 接口 [概览-我的资源↗](http://10.19.12.152:8989/project/502/interface/api/29273) 的 **React Hook**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/overview/resource`
 * @更新时间 `2026-01-15 17:24:14`
 */
export const useApiGetDomeosOverviewResource = /*#__PURE__*/ makeRequestHook<
  ApiGetDomeosOverviewResourceRequest,
  ApiGetDomeosOverviewResourceRequestConfig,
  ReturnType<typeof apiGetDomeosOverviewResource>
>(apiGetDomeosOverviewResource)

/**
 * 接口 [概览-异常部署↗](http://10.19.12.152:8989/project/502/interface/api/29280) 的 **请求类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `待确认`
 * @请求头 `GET /api/app/domeos/overview/deploy`
 * @更新时间 `2025-08-21 16:19:12`
 */
export interface ApiGetDomeosOverviewDeployRequest {
  states: string
  startIndex: string
  length: string
  search?: string
}

/**
 * 接口 [概览-异常部署↗](http://10.19.12.152:8989/project/502/interface/api/29280) 的 **返回类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `待确认`
 * @请求头 `GET /api/app/domeos/overview/deploy`
 * @更新时间 `2025-08-21 16:19:12`
 */
export interface ApiGetDomeosOverviewDeployResponse {
  firstId: string
  /**
   * 部署总数
   */
  total: number
  values: {
    id: number
    /**
     * 部署名
     */
    name: string
    /**
     * 描述
     */
    description: string
    /**
     * 状态
     */
    state: string
    createTime: number
    removeTime: number
    removed: boolean
    /**
     * 所属服务
     */
    namespace: string
    /**
     * 资源包id
     */
    bundleId: number
    clusterId: number
    type: string
    networkMode: string
    deploymentType: string
    lastUpdateTime: number
    ignorePortConflict: boolean
    lockRes: boolean
    /**
     * 角色
     */
    role: string
    creator: {
      id: number
      name: string
    }
    bundle: {
      id: number
      name: string
    }
    cluster: {
      id: number
      name: string
    }
    /**
     * 所属服务信息
     */
    collectionInfo: {
      id: number
      name: string
    }
    cpuTotal: number
    cpuUsed: number
    memoryTotal: number
    memoryUsed: number
    currentReplicas: number
    operationTime: number
    supportCustomConfig: boolean
  }[]
}

/**
 * 接口 [概览-异常部署↗](http://10.19.12.152:8989/project/502/interface/api/29280) 的 **请求配置的类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `待确认`
 * @请求头 `GET /api/app/domeos/overview/deploy`
 * @更新时间 `2025-08-21 16:19:12`
 */
type ApiGetDomeosOverviewDeployRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/domeos/overview/deploy',
    'data',
    string,
    'states' | 'startIndex' | 'length' | 'search',
    false
  >
>

/**
 * 接口 [概览-异常部署↗](http://10.19.12.152:8989/project/502/interface/api/29280) 的 **请求配置**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `待确认`
 * @请求头 `GET /api/app/domeos/overview/deploy`
 * @更新时间 `2025-08-21 16:19:12`
 */
const apiGetDomeosOverviewDeployRequestConfig: ApiGetDomeosOverviewDeployRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/api/app/domeos/overview/deploy',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: [],
    queryNames: ['states', 'startIndex', 'length', 'search'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetDomeosOverviewDeploy',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [概览-异常部署↗](http://10.19.12.152:8989/project/502/interface/api/29280) 的 **请求函数**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `待确认`
 * @请求头 `GET /api/app/domeos/overview/deploy`
 * @更新时间 `2025-08-21 16:19:12`
 */
const apiGetDomeosOverviewDeploy = /*#__PURE__*/ (
  requestData: ApiGetDomeosOverviewDeployRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetDomeosOverviewDeployResponse>(
    prepare(apiGetDomeosOverviewDeployRequestConfig, requestData),
    ...args
  )
}

apiGetDomeosOverviewDeploy.requestConfig =
  apiGetDomeosOverviewDeployRequestConfig

/**
 * 接口 [概览-异常部署↗](http://10.19.12.152:8989/project/502/interface/api/29280) 的 **React Hook**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `待确认`
 * @请求头 `GET /api/app/domeos/overview/deploy`
 * @更新时间 `2025-08-21 16:19:12`
 */
export const useApiGetDomeosOverviewDeploy = /*#__PURE__*/ makeRequestHook<
  ApiGetDomeosOverviewDeployRequest,
  ApiGetDomeosOverviewDeployRequestConfig,
  ReturnType<typeof apiGetDomeosOverviewDeploy>
>(apiGetDomeosOverviewDeploy)

/**
 * 接口 [概览-未恢复报警↗](http://10.19.12.152:8989/project/502/interface/api/29287) 的 **请求类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `待确认`
 * @请求头 `GET /api/app/domeos/overview/alarm/event`
 * @更新时间 `2025-08-12 16:04:56`
 */
export interface ApiGetDomeosOverviewAlarmEventRequest {
  states: string
}

/**
 * 接口 [概览-未恢复报警↗](http://10.19.12.152:8989/project/502/interface/api/29287) 的 **返回类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `待确认`
 * @请求头 `GET /api/app/domeos/overview/alarm/event`
 * @更新时间 `2025-08-12 16:04:56`
 */
export type ApiGetDomeosOverviewAlarmEventResponse = {
  id: number
  name: string
  description: string
  state: string
  createTime: number
  removeTime: number
  removed: boolean
  /**
   * 报警时间
   */
  lastAlarmTime: number
  templateId: number
  templateName: string
  strategyId: number
  alarmCollectionId: number
  strategyType: string
  metric: string
  operatorType: string
  rightValue: number
  alarmNumber: string
  alarmType: string
  tag: string
  role: string
  alarmCollection: {
    id: number
    name: string
  }
  targetId: number
  clusterId: number
  silenceId: null
  appendInfo: {
    resoureName: string
    collectionName: string
  }
  statusData: null
}[]

/**
 * 接口 [概览-未恢复报警↗](http://10.19.12.152:8989/project/502/interface/api/29287) 的 **请求配置的类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `待确认`
 * @请求头 `GET /api/app/domeos/overview/alarm/event`
 * @更新时间 `2025-08-12 16:04:56`
 */
type ApiGetDomeosOverviewAlarmEventRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/domeos/overview/alarm/event',
    'data',
    string,
    'states',
    false
  >
>

/**
 * 接口 [概览-未恢复报警↗](http://10.19.12.152:8989/project/502/interface/api/29287) 的 **请求配置**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `待确认`
 * @请求头 `GET /api/app/domeos/overview/alarm/event`
 * @更新时间 `2025-08-12 16:04:56`
 */
const apiGetDomeosOverviewAlarmEventRequestConfig: ApiGetDomeosOverviewAlarmEventRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/api/app/domeos/overview/alarm/event',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: [],
    queryNames: ['states'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetDomeosOverviewAlarmEvent',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [概览-未恢复报警↗](http://10.19.12.152:8989/project/502/interface/api/29287) 的 **请求函数**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `待确认`
 * @请求头 `GET /api/app/domeos/overview/alarm/event`
 * @更新时间 `2025-08-12 16:04:56`
 */
const apiGetDomeosOverviewAlarmEvent = /*#__PURE__*/ (
  requestData: ApiGetDomeosOverviewAlarmEventRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetDomeosOverviewAlarmEventResponse>(
    prepare(apiGetDomeosOverviewAlarmEventRequestConfig, requestData),
    ...args
  )
}

apiGetDomeosOverviewAlarmEvent.requestConfig =
  apiGetDomeosOverviewAlarmEventRequestConfig

/**
 * 接口 [概览-未恢复报警↗](http://10.19.12.152:8989/project/502/interface/api/29287) 的 **React Hook**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `待确认`
 * @请求头 `GET /api/app/domeos/overview/alarm/event`
 * @更新时间 `2025-08-12 16:04:56`
 */
export const useApiGetDomeosOverviewAlarmEvent = /*#__PURE__*/ makeRequestHook<
  ApiGetDomeosOverviewAlarmEventRequest,
  ApiGetDomeosOverviewAlarmEventRequestConfig,
  ReturnType<typeof apiGetDomeosOverviewAlarmEvent>
>(apiGetDomeosOverviewAlarmEvent)

/**
 * 接口 [概览-操作记录↗](http://10.19.12.152:8989/project/502/interface/api/29294) 的 **请求类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/overview/operation`
 * @更新时间 `2025-08-18 14:14:51`
 */
export interface ApiGetDomeosOverviewOperationRequest {
  startIndex: string
  length: string
}

/**
 * 接口 [概览-操作记录↗](http://10.19.12.152:8989/project/502/interface/api/29294) 的 **返回类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/overview/operation`
 * @更新时间 `2025-08-18 14:14:51`
 */
export type ApiGetDomeosOverviewOperationResponse = {
  id: number
  resourceId: number
  /**
   * VERSION:添加版本；DEPLOY: 升级了部署
   */
  resourceType: string
  /**
   * 服务id
   */
  collectionId: number
  collectionType: string
  /**
   * 操作
   */
  operation: string
  userId: number
  /**
   * 操作时间
   */
  operateTime: number
  /**
   * 操作用户
   */
  userName: string
  /**
   * 资源名（版本名）
   */
  resourceName: string
  /**
   * 服务名
   */
  collectionName: string
  /**
   * 上一级资源
   */
  fatherResource: {
    id: number
    name: string
    description: null
    createTime: number
    resourceType: string
  }
}[]

/**
 * 接口 [概览-操作记录↗](http://10.19.12.152:8989/project/502/interface/api/29294) 的 **请求配置的类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/overview/operation`
 * @更新时间 `2025-08-18 14:14:51`
 */
type ApiGetDomeosOverviewOperationRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/domeos/overview/operation',
    'data',
    string,
    'startIndex' | 'length',
    false
  >
>

/**
 * 接口 [概览-操作记录↗](http://10.19.12.152:8989/project/502/interface/api/29294) 的 **请求配置**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/overview/operation`
 * @更新时间 `2025-08-18 14:14:51`
 */
const apiGetDomeosOverviewOperationRequestConfig: ApiGetDomeosOverviewOperationRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/api/app/domeos/overview/operation',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: [],
    queryNames: ['startIndex', 'length'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetDomeosOverviewOperation',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [概览-操作记录↗](http://10.19.12.152:8989/project/502/interface/api/29294) 的 **请求函数**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/overview/operation`
 * @更新时间 `2025-08-18 14:14:51`
 */
const apiGetDomeosOverviewOperation = /*#__PURE__*/ (
  requestData: ApiGetDomeosOverviewOperationRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetDomeosOverviewOperationResponse>(
    prepare(apiGetDomeosOverviewOperationRequestConfig, requestData),
    ...args
  )
}

apiGetDomeosOverviewOperation.requestConfig =
  apiGetDomeosOverviewOperationRequestConfig

/**
 * 接口 [概览-操作记录↗](http://10.19.12.152:8989/project/502/interface/api/29294) 的 **React Hook**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/overview/operation`
 * @更新时间 `2025-08-18 14:14:51`
 */
export const useApiGetDomeosOverviewOperation = /*#__PURE__*/ makeRequestHook<
  ApiGetDomeosOverviewOperationRequest,
  ApiGetDomeosOverviewOperationRequestConfig,
  ReturnType<typeof apiGetDomeosOverviewOperation>
>(apiGetDomeosOverviewOperation)

/**
 * 接口 [服务-服务列表↗](http://10.19.12.152:8989/project/502/interface/api/29322) 的 **请求类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/deploycollection`
 * @更新时间 `2025-08-12 16:20:12`
 */
export interface ApiGetDomeosDeploycollectionRequest {}

/**
 * 接口 [服务-服务列表↗](http://10.19.12.152:8989/project/502/interface/api/29322) 的 **返回类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/deploycollection`
 * @更新时间 `2025-08-12 16:20:12`
 */
export type ApiGetDomeosDeploycollectionResponse = {
  id: number
  /**
   * 服务名
   */
  name: string
  /**
   * 描述
   */
  description: string
  state: string
  /**
   * 创建时间
   */
  createTime: number
  removeTime: number
  removed: boolean
  creatorId: number
  namespace: string
  /**
   * 创建者
   */
  creator: {
    id: number
    /**
     * 创建人邮箱
     */
    name: string
  }
  /**
   * 成员数量
   */
  memberCount: number
  /**
   * 部署数量
   */
  deployCount: number
  role: string
}[]

/**
 * 接口 [服务-服务列表↗](http://10.19.12.152:8989/project/502/interface/api/29322) 的 **请求配置的类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/deploycollection`
 * @更新时间 `2025-08-12 16:20:12`
 */
type ApiGetDomeosDeploycollectionRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/domeos/deploycollection',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [服务-服务列表↗](http://10.19.12.152:8989/project/502/interface/api/29322) 的 **请求配置**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/deploycollection`
 * @更新时间 `2025-08-12 16:20:12`
 */
const apiGetDomeosDeploycollectionRequestConfig: ApiGetDomeosDeploycollectionRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/api/app/domeos/deploycollection',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetDomeosDeploycollection',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [服务-服务列表↗](http://10.19.12.152:8989/project/502/interface/api/29322) 的 **请求函数**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/deploycollection`
 * @更新时间 `2025-08-12 16:20:12`
 */
const apiGetDomeosDeploycollection = /*#__PURE__*/ (
  requestData?: ApiGetDomeosDeploycollectionRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetDomeosDeploycollectionResponse>(
    prepare(apiGetDomeosDeploycollectionRequestConfig, requestData),
    ...args
  )
}

apiGetDomeosDeploycollection.requestConfig =
  apiGetDomeosDeploycollectionRequestConfig

/**
 * 接口 [服务-服务列表↗](http://10.19.12.152:8989/project/502/interface/api/29322) 的 **React Hook**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/deploycollection`
 * @更新时间 `2025-08-12 16:20:12`
 */
export const useApiGetDomeosDeploycollection = /*#__PURE__*/ makeRequestHook<
  ApiGetDomeosDeploycollectionRequest,
  ApiGetDomeosDeploycollectionRequestConfig,
  ReturnType<typeof apiGetDomeosDeploycollection>
>(apiGetDomeosDeploycollection)

/**
 * 接口 [服务-部署列表↗](http://10.19.12.152:8989/project/502/interface/api/29336) 的 **请求类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/deploy/collection/{deploycollectionId}`
 * @更新时间 `2025-08-12 16:22:42`
 */
export interface ApiGetDomeosDeployCollectionDeploycollectionIdRequest {
  /**
   * 服务id
   */
  deploycollectionId: string
}

/**
 * 接口 [服务-部署列表↗](http://10.19.12.152:8989/project/502/interface/api/29336) 的 **返回类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/deploy/collection/{deploycollectionId}`
 * @更新时间 `2025-08-12 16:22:42`
 */
export type ApiGetDomeosDeployCollectionDeploycollectionIdResponse = {
  id: number
  /**
   * 部署名
   */
  name: string
  /**
   * 描述
   */
  description: string
  /**
   * 状态
   */
  state: string
  createTime: number
  removeTime: number
  removed: boolean
  /**
   * 服务名
   */
  namespace: string
  /**
   * 资源包id
   */
  bundleId: number
  clusterId: number
  /**
   * 类型：DEPLOY:部署
   */
  type: string
  networkMode: string
  deploymentType: string
  /**
   * 升级时间
   */
  lastUpdateTime: number
  versionNamePattern: null | string
  ignorePortConflict: boolean
  lockRes: boolean
  role: string
  creator: {
    id: number
    name: string
  }
  bundle: {
    id: number
    name: string
  }
  cluster: {
    id: number
    name: string
  }
  /**
   * 服务信息
   */
  collectionInfo: {
    id: number
    name: string
  }
  cpuTotal: number
  cpuUsed: number
  memoryTotal: number
  memoryUsed: number
  currentReplicas: number
  currentVersions: null
  operationTime: number
  supportCustomConfig: boolean
  lbType: null
  lbPorts: null
}[]

/**
 * 接口 [服务-部署列表↗](http://10.19.12.152:8989/project/502/interface/api/29336) 的 **请求配置的类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/deploy/collection/{deploycollectionId}`
 * @更新时间 `2025-08-12 16:22:42`
 */
type ApiGetDomeosDeployCollectionDeploycollectionIdRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/domeos/deploy/collection/{deploycollectionId}',
    'data',
    'deploycollectionId',
    string,
    false
  >
>

/**
 * 接口 [服务-部署列表↗](http://10.19.12.152:8989/project/502/interface/api/29336) 的 **请求配置**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/deploy/collection/{deploycollectionId}`
 * @更新时间 `2025-08-12 16:22:42`
 */
const apiGetDomeosDeployCollectionDeploycollectionIdRequestConfig: ApiGetDomeosDeployCollectionDeploycollectionIdRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/api/app/domeos/deploy/collection/{deploycollectionId}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: ['deploycollectionId'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetDomeosDeployCollectionDeploycollectionId',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [服务-部署列表↗](http://10.19.12.152:8989/project/502/interface/api/29336) 的 **请求函数**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/deploy/collection/{deploycollectionId}`
 * @更新时间 `2025-08-12 16:22:42`
 */
const apiGetDomeosDeployCollectionDeploycollectionId = /*#__PURE__*/ (
  requestData: ApiGetDomeosDeployCollectionDeploycollectionIdRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetDomeosDeployCollectionDeploycollectionIdResponse>(
    prepare(
      apiGetDomeosDeployCollectionDeploycollectionIdRequestConfig,
      requestData
    ),
    ...args
  )
}

apiGetDomeosDeployCollectionDeploycollectionId.requestConfig =
  apiGetDomeosDeployCollectionDeploycollectionIdRequestConfig

/**
 * 接口 [服务-部署列表↗](http://10.19.12.152:8989/project/502/interface/api/29336) 的 **React Hook**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/deploy/collection/{deploycollectionId}`
 * @更新时间 `2025-08-12 16:22:42`
 */
export const useApiGetDomeosDeployCollectionDeploycollectionId =
  /*#__PURE__*/ makeRequestHook<
    ApiGetDomeosDeployCollectionDeploycollectionIdRequest,
    ApiGetDomeosDeployCollectionDeploycollectionIdRequestConfig,
    ReturnType<typeof apiGetDomeosDeployCollectionDeploycollectionId>
  >(apiGetDomeosDeployCollectionDeploycollectionId)

/**
 * 接口 [部署=部署详情↗](http://10.19.12.152:8989/project/502/interface/api/29343) 的 **请求类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/deploy/{deployId}`
 * @更新时间 `2025-08-18 16:19:05`
 */
export interface ApiGetDomeosDeployDeployIdRequest {
  deployId: string
}

/**
 * 接口 [部署=部署详情↗](http://10.19.12.152:8989/project/502/interface/api/29343) 的 **返回类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/deploy/{deployId}`
 * @更新时间 `2025-08-18 16:19:05`
 */
export interface ApiGetDomeosDeployDeployIdResponse {
  /**
   * 部署id
   */
  id: number
  /**
   * 部署名
   */
  name: string
  /**
   * 描述
   */
  description: string
  /**
   * RUNNING;
   */
  state: string
  /**
   * 创建时间
   */
  createTime: number
  removeTime: number
  removed: boolean
  /**
   * 资源包名
   */
  namespace: string
  /**
   * 资源包id
   */
  bundleId: number
  clusterId: number
  /**
   * DEPLOY
   */
  type: string
  /**
   * 网络模式
   */
  networkMode: string
  /**
   * 部署类型 DEPLOYMENT
   */
  deploymentType: string
  /**
   * 上次升级时间
   */
  lastUpdateTime: number
  versionNamePattern: string
  ignorePortConflict: boolean
  lockRes: boolean
  /**
   * 角色
   */
  role: string
  creator: {
    id: number
    name: string
  }
  bundle: {
    id: number
    name: string
  }
  cluster: {
    id: number
    name: string
  }
  collectionInfo: {
    id: number
    name: string
  }
  cpuTotal: number
  cpuUsed: number
  memoryTotal: number
  memoryUsed: number
  /**
   * 实例数
   */
  currentReplicas: number
  /**
   * 当前版本信息
   */
  currentVersions: {
    /**
     * 版本id
     */
    id: number
    /**
     * 版本名
     */
    name: string
    /**
     * 描述
     */
    description: string
    state: string
    createTime: number
    removeTime: number
    removed: boolean
    graceTime: number
    /**
     * 部署id
     */
    deployId: number
    /**
     * 版本号
     */
    version: number
    podSpecStr: string
    versionType: string
    containers: {
      name: string
      envs: {
        key: string
        value: string
        description: null
      }[]
      command: string
      enableLxcfs: boolean
      gpuLimit: number
      gpuRequest: number
      gpuMemLimit: number
      gpuMemRequest: number
      nvshareGpuLimit: number
      nvshareGpuRequest: number
      timeSliceGpuLimit: number
      timeSliceGpuRequest: number
      hamiGpuQuotaLimit: number
      hamiGpuCoresLimit: number
      hamiGpuMemLimit: number
      cpuLimit: number
      cpuRequest: number
      memLimit: number
      memRequest: number
      imageInfo: {
        registry: string
        /**
         * 工程名
         */
        name: string
        tag: string
        type: string
      }
      logItems: string
      lokiLogItems: string
      configs: string
      autoDeploy: boolean
      healthChecker: {}
      readinessChecker: {
        port: number
        delay: number
        timeout: number
        failureThreshold: number
        successThreshold: number
        periodSeconds: number
        url: null
        type: string
      }
      startupChecker: {}
      volumeMounts: {
        name: null
        hostPath: string
        emptyDir: null
        volumePVC: null
        containerPath: string
        volumeType: string
        readonly: boolean
        pathType: null
        dynamicVolume: boolean
        cephcsiv1: boolean
        mountPropagation: null
      }[]
      imagePullPolicy: string
      logConfig: number
      lifecycle: {
        postStart: null
        preStop: null
      }
      containerType: string
      securityContext: {}
      privileged: boolean
    }[]
    /**
     * 必需主机标签
     */
    labelSelectors: string[]
    hostAliases: string
    hostList: string
    affinityType: null
    /**
     * 优先主机标签
     */
    nodeAffinityPreferance: string[]
    /**
     * 排除主机标签
     */
    nodeAntiAffinityRequired: string[]
    sysctls: null
    promMetrics: null
    versionPodDNSConfig: {
      nameservers: null
      searches: null
      options: null
      desc: number
    }
    sharedHostNS: null
    consulService: null
    traceConfigInfo: null
    flumeLogConfigInfo: {
      id: number
      name: string
      serviceName: null
    }
    lokiLogConfigInfo: {
      id: number
      name: string
      serviceName: null
    }
    traceConfig: null
    lokiLogConfig: null
    istioInjection: boolean
    enableYarnHpa: boolean
    foxEyeMetricsConfigInfo: null
    deprecate: boolean
    autoDeploy: boolean
  }[]
  /**
   * 操作时间
   */
  operationTime: number
  supportCustomConfig: boolean
  lbType?: string
  lbPorts?: string
}

/**
 * 接口 [部署=部署详情↗](http://10.19.12.152:8989/project/502/interface/api/29343) 的 **请求配置的类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/deploy/{deployId}`
 * @更新时间 `2025-08-18 16:19:05`
 */
type ApiGetDomeosDeployDeployIdRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/domeos/deploy/{deployId}',
    'data',
    'deployId',
    string,
    false
  >
>

/**
 * 接口 [部署=部署详情↗](http://10.19.12.152:8989/project/502/interface/api/29343) 的 **请求配置**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/deploy/{deployId}`
 * @更新时间 `2025-08-18 16:19:05`
 */
const apiGetDomeosDeployDeployIdRequestConfig: ApiGetDomeosDeployDeployIdRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/api/app/domeos/deploy/{deployId}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: ['deployId'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetDomeosDeployDeployId',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [部署=部署详情↗](http://10.19.12.152:8989/project/502/interface/api/29343) 的 **请求函数**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/deploy/{deployId}`
 * @更新时间 `2025-08-18 16:19:05`
 */
const apiGetDomeosDeployDeployId = /*#__PURE__*/ (
  requestData: ApiGetDomeosDeployDeployIdRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetDomeosDeployDeployIdResponse>(
    prepare(apiGetDomeosDeployDeployIdRequestConfig, requestData),
    ...args
  )
}

apiGetDomeosDeployDeployId.requestConfig =
  apiGetDomeosDeployDeployIdRequestConfig

/**
 * 接口 [部署=部署详情↗](http://10.19.12.152:8989/project/502/interface/api/29343) 的 **React Hook**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/deploy/{deployId}`
 * @更新时间 `2025-08-18 16:19:05`
 */
export const useApiGetDomeosDeployDeployId = /*#__PURE__*/ makeRequestHook<
  ApiGetDomeosDeployDeployIdRequest,
  ApiGetDomeosDeployDeployIdRequestConfig,
  ReturnType<typeof apiGetDomeosDeployDeployId>
>(apiGetDomeosDeployDeployId)

/**
 * 接口 [部署=实例列表↗](http://10.19.12.152:8989/project/502/interface/api/29364) 的 **请求类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/deploy/{deployId}/instance`
 * @更新时间 `2025-08-20 14:30:15`
 */
export interface ApiGetDomeosDeployDeployIdInstanceRequest {
  deployId: string
}

/**
 * 接口 [部署=实例列表↗](http://10.19.12.152:8989/project/502/interface/api/29364) 的 **返回类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/deploy/{deployId}/instance`
 * @更新时间 `2025-08-20 14:30:15`
 */
export type ApiGetDomeosDeployDeployIdInstanceResponse = {
  ip: string
  /**
   * 实例名
   */
  name: string
  clusterId: number
  deployInfo: {
    id: number
    name: string
  }
  /**
   * 所属服务名
   */
  namespace: string
  /**
   * 版本信息
   */
  versionInfo: {
    id: number
    name: string
  }
  startTime: number
  /**
   * 主机名
   */
  hostname: string
  /**
   * 主机ip
   */
  nodeIp: string
  /**
   * Running
   */
  status: string
  statusUrl: null
  /**
   * DEPLOY
   */
  deployResourceType: string
  containers: {
    id: string
    name: string
    image: string
    lastState: null
    ready: boolean
  }[]
  resources: {
    cpuLimit: number
    cpuRequest: number
    memLimit: number
    memRequest: number
  }
}[]

/**
 * 接口 [部署=实例列表↗](http://10.19.12.152:8989/project/502/interface/api/29364) 的 **请求配置的类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/deploy/{deployId}/instance`
 * @更新时间 `2025-08-20 14:30:15`
 */
type ApiGetDomeosDeployDeployIdInstanceRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/domeos/deploy/{deployId}/instance',
    'data',
    'deployId',
    string,
    false
  >
>

/**
 * 接口 [部署=实例列表↗](http://10.19.12.152:8989/project/502/interface/api/29364) 的 **请求配置**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/deploy/{deployId}/instance`
 * @更新时间 `2025-08-20 14:30:15`
 */
const apiGetDomeosDeployDeployIdInstanceRequestConfig: ApiGetDomeosDeployDeployIdInstanceRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/api/app/domeos/deploy/{deployId}/instance',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: ['deployId'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetDomeosDeployDeployIdInstance',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [部署=实例列表↗](http://10.19.12.152:8989/project/502/interface/api/29364) 的 **请求函数**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/deploy/{deployId}/instance`
 * @更新时间 `2025-08-20 14:30:15`
 */
const apiGetDomeosDeployDeployIdInstance = /*#__PURE__*/ (
  requestData: ApiGetDomeosDeployDeployIdInstanceRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetDomeosDeployDeployIdInstanceResponse>(
    prepare(apiGetDomeosDeployDeployIdInstanceRequestConfig, requestData),
    ...args
  )
}

apiGetDomeosDeployDeployIdInstance.requestConfig =
  apiGetDomeosDeployDeployIdInstanceRequestConfig

/**
 * 接口 [部署=实例列表↗](http://10.19.12.152:8989/project/502/interface/api/29364) 的 **React Hook**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/deploy/{deployId}/instance`
 * @更新时间 `2025-08-20 14:30:15`
 */
export const useApiGetDomeosDeployDeployIdInstance =
  /*#__PURE__*/ makeRequestHook<
    ApiGetDomeosDeployDeployIdInstanceRequest,
    ApiGetDomeosDeployDeployIdInstanceRequestConfig,
    ReturnType<typeof apiGetDomeosDeployDeployIdInstance>
  >(apiGetDomeosDeployDeployIdInstance)

/**
 * 接口 [部署=升级列表↗](http://10.19.12.152:8989/project/502/interface/api/29371) 的 **请求类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/deploy/{deployId}/recentevent`
 * @更新时间 `2025-08-13 17:58:53`
 */
export interface ApiGetDomeosDeployDeployIdRecenteventRequest {
  deployId: string
}

/**
 * 接口 [部署=升级列表↗](http://10.19.12.152:8989/project/502/interface/api/29371) 的 **返回类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/deploy/{deployId}/recentevent`
 * @更新时间 `2025-08-13 17:58:53`
 */
export type ApiGetDomeosDeployDeployIdRecenteventResponse = {
  id: number
  deployId: number
  operation: string
  eventKind: null
  status: string
  statusExpire: number
  count: number
  reason: null
  startTime: number
  /**
   * 操作时间
   */
  lastModify: number
  userId: number
  userName: string
  message: null
  primarySnapshot: null
  /**
   * 目标版本
   */
  targetSnapshot: {
    /**
     * 版本号
     */
    version: number
    /**
     * 版本名
     */
    versionName: string
    /**
     * 实例数
     */
    replicas: number
    policy: {
      maxUnavailable: number
      maxSurge: number
      minReadySeconds: number
    }
    k8sDeployName: string
    horizontalPodAutoScale: {
      hpaRuleId: number
      hpaRuleName: null
      type: null
      minReplicas: number
      maxReplicas: number
      targetCPUPercentage: number
    }
  }[]
  currentSnapshot: {
    version: number
    versionName: string
    replicas: number
    policy: {
      maxUnavailable: number
      maxSurge: number
      minReadySeconds: number
    }
    k8sDeployName: string
    horizontalPodAutoScale: {
      hpaRuleId: number
      hpaRuleName: null
      type: null
      minReplicas: number
      maxReplicas: number
      targetCPUPercentage: number
    }
  }[]
}[]

/**
 * 接口 [部署=升级列表↗](http://10.19.12.152:8989/project/502/interface/api/29371) 的 **请求配置的类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/deploy/{deployId}/recentevent`
 * @更新时间 `2025-08-13 17:58:53`
 */
type ApiGetDomeosDeployDeployIdRecenteventRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/domeos/deploy/{deployId}/recentevent',
    'data',
    'deployId',
    string,
    false
  >
>

/**
 * 接口 [部署=升级列表↗](http://10.19.12.152:8989/project/502/interface/api/29371) 的 **请求配置**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/deploy/{deployId}/recentevent`
 * @更新时间 `2025-08-13 17:58:53`
 */
const apiGetDomeosDeployDeployIdRecenteventRequestConfig: ApiGetDomeosDeployDeployIdRecenteventRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/api/app/domeos/deploy/{deployId}/recentevent',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: ['deployId'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetDomeosDeployDeployIdRecentevent',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [部署=升级列表↗](http://10.19.12.152:8989/project/502/interface/api/29371) 的 **请求函数**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/deploy/{deployId}/recentevent`
 * @更新时间 `2025-08-13 17:58:53`
 */
const apiGetDomeosDeployDeployIdRecentevent = /*#__PURE__*/ (
  requestData: ApiGetDomeosDeployDeployIdRecenteventRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetDomeosDeployDeployIdRecenteventResponse>(
    prepare(apiGetDomeosDeployDeployIdRecenteventRequestConfig, requestData),
    ...args
  )
}

apiGetDomeosDeployDeployIdRecentevent.requestConfig =
  apiGetDomeosDeployDeployIdRecenteventRequestConfig

/**
 * 接口 [部署=升级列表↗](http://10.19.12.152:8989/project/502/interface/api/29371) 的 **React Hook**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/deploy/{deployId}/recentevent`
 * @更新时间 `2025-08-13 17:58:53`
 */
export const useApiGetDomeosDeployDeployIdRecentevent =
  /*#__PURE__*/ makeRequestHook<
    ApiGetDomeosDeployDeployIdRecenteventRequest,
    ApiGetDomeosDeployDeployIdRecenteventRequestConfig,
    ReturnType<typeof apiGetDomeosDeployDeployIdRecentevent>
  >(apiGetDomeosDeployDeployIdRecentevent)

/**
 * 接口 [部署=升级\/停止\/启动↗](http://10.19.12.152:8989/project/502/interface/api/29385) 的 **请求类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `POST /api/app/domeos/deploy/operation`
 * @更新时间 `2025-08-14 17:50:45`
 */
export interface ApiPostDomeosDeployOperationRequest {
  /**
   * 部署id
   */
  deployId?: number
  /**
   * 快照信息
   */
  snapshots?: {
    /**
     * k8s部署名
     */
    k8sDeployName?: string
    policy?: {
      maxUnavailable?: number
      maxSurge?: number
      minReadySeconds?: number
    }
    /**
     * 版本号
     */
    version?: number
    /**
     * 实例数
     */
    replicas?: number
    horizontalPodAutoScale?: null
  }[]
  /**
   * UPDATE ; STOP; START;
   */
  operation?: string
}

/**
 * 接口 [部署=升级\/停止\/启动↗](http://10.19.12.152:8989/project/502/interface/api/29385) 的 **返回类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `POST /api/app/domeos/deploy/operation`
 * @更新时间 `2025-08-14 17:50:45`
 */
export interface ApiPostDomeosDeployOperationResponse {}

/**
 * 接口 [部署=升级\/停止\/启动↗](http://10.19.12.152:8989/project/502/interface/api/29385) 的 **请求配置的类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `POST /api/app/domeos/deploy/operation`
 * @更新时间 `2025-08-14 17:50:45`
 */
type ApiPostDomeosDeployOperationRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/domeos/deploy/operation',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [部署=升级\/停止\/启动↗](http://10.19.12.152:8989/project/502/interface/api/29385) 的 **请求配置**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `POST /api/app/domeos/deploy/operation`
 * @更新时间 `2025-08-14 17:50:45`
 */
const apiPostDomeosDeployOperationRequestConfig: ApiPostDomeosDeployOperationRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/api/app/domeos/deploy/operation',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPostDomeosDeployOperation',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [部署=升级\/停止\/启动↗](http://10.19.12.152:8989/project/502/interface/api/29385) 的 **请求函数**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `POST /api/app/domeos/deploy/operation`
 * @更新时间 `2025-08-14 17:50:45`
 */
const apiPostDomeosDeployOperation = /*#__PURE__*/ (
  requestData: ApiPostDomeosDeployOperationRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPostDomeosDeployOperationResponse>(
    prepare(apiPostDomeosDeployOperationRequestConfig, requestData),
    ...args
  )
}

apiPostDomeosDeployOperation.requestConfig =
  apiPostDomeosDeployOperationRequestConfig

/**
 * 接口 [部署=升级\/停止\/启动↗](http://10.19.12.152:8989/project/502/interface/api/29385) 的 **React Hook**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `POST /api/app/domeos/deploy/operation`
 * @更新时间 `2025-08-14 17:50:45`
 */
export const useApiPostDomeosDeployOperation = /*#__PURE__*/ makeRequestHook<
  ApiPostDomeosDeployOperationRequest,
  ApiPostDomeosDeployOperationRequestConfig,
  ReturnType<typeof apiPostDomeosDeployOperation>
>(apiPostDomeosDeployOperation)

/**
 * 接口 [部署=版本详情↗](http://10.19.12.152:8989/project/502/interface/api/29406) 的 **请求类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/deployversion/deploy/{deployId}/{version}`
 * @更新时间 `2025-08-18 16:18:15`
 */
export interface ApiGetDomeosDeployversionDeployDeployIdVersionRequest {
  /**
   * 部署id
   */
  deployId: string
  version: string
}

/**
 * 接口 [部署=版本详情↗](http://10.19.12.152:8989/project/502/interface/api/29406) 的 **返回类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/deployversion/deploy/{deployId}/{version}`
 * @更新时间 `2025-08-18 16:18:15`
 */
export interface ApiGetDomeosDeployversionDeployDeployIdVersionResponse {
  id: number
  /**
   * 版本名
   */
  name: string
  description: string
  state: string
  createTime: number
  removeTime: number
  removed: boolean
  graceTime: number
  /**
   * 部署id
   */
  deployId: number
  /**
   * 版本号
   */
  version: number
  podSpecStr: null
  /**
   * 版本类型 CUSTOM
   */
  versionType: string
  containers: {
    name: string
    /**
     * 环境变量
     */
    envs: {
      key: string
      value: string
      description: null
    }[]
    command: null
    enableLxcfs: boolean
    gpuLimit: number
    gpuRequest: number
    gpuMemLimit: number
    gpuMemRequest: number
    nvshareGpuLimit: number
    nvshareGpuRequest: number
    timeSliceGpuLimit: number
    timeSliceGpuRequest: number
    hamiGpuQuotaLimit: number
    hamiGpuCoresLimit: number
    hamiGpuMemLimit: number
    cpuLimit: number
    cpuRequest: number
    memLimit: number
    memRequest: number
    /**
     * 镜像信息
     */
    imageInfo: {
      registry: string
      name: string
      tag: string
      type: string
    }
    logItems: null
    lokiLogItems: null
    configs: null
    autoDeploy: boolean
    healthChecker: null
    /**
     * 就绪检查
     */
    readinessChecker: {
      port: number
      delay: number
      timeout: number
      failureThreshold: number
      successThreshold: number
      periodSeconds: number
      url: null
      type: string
    }
    startupChecker: null
    /**
     * 挂载存储
     */
    volumeMounts: {
      name: null
      /**
       * 主机地址
       */
      hostPath: string
      emptyDir: null
      volumePVC: null
      /**
       * 容器地址
       */
      containerPath: string
      volumeType: string
      readonly: boolean
      pathType: null
      dynamicVolume: boolean
      cephcsiv1: boolean
      mountPropagation: null
    }[]
    /**
     * 拉去策略
     */
    imagePullPolicy: string
    logConfig: number
    lifecycle: {
      postStart: null
      preStop: null
    }
    containerType: string
    securityContext: null
    privileged: boolean
  }[]
  /**
   * 必选标签
   */
  labelSelectors: string[]
  hostAliases: string
  hostList: string[]
  affinityType: string
  /**
   * 优先主机标签
   */
  nodeAffinityPreferance: string[]
  /**
   * 排除主机标签
   */
  nodeAntiAffinityRequired: string[]
  sysctls: string
  promMetrics: null
  versionPodDNSConfig: {
    nameservers: null
    searches: null
    options: null
    desc: number
  }
  sharedHostNS: string
  consulService: string
  traceConfigInfo: string
  flumeLogConfigInfo: string
  lokiLogConfigInfo: {
    id: number
    name: string
    serviceName: null
  }
  traceConfig: string
  lokiLogConfig: string
  istioInjection: boolean
  enableYarnHpa: boolean
  deprecate: boolean
  autoDeploy: boolean
}

/**
 * 接口 [部署=版本详情↗](http://10.19.12.152:8989/project/502/interface/api/29406) 的 **请求配置的类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/deployversion/deploy/{deployId}/{version}`
 * @更新时间 `2025-08-18 16:18:15`
 */
type ApiGetDomeosDeployversionDeployDeployIdVersionRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/domeos/deployversion/deploy/{deployId}/{version}',
    'data',
    'deployId' | 'version',
    string,
    false
  >
>

/**
 * 接口 [部署=版本详情↗](http://10.19.12.152:8989/project/502/interface/api/29406) 的 **请求配置**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/deployversion/deploy/{deployId}/{version}`
 * @更新时间 `2025-08-18 16:18:15`
 */
const apiGetDomeosDeployversionDeployDeployIdVersionRequestConfig: ApiGetDomeosDeployversionDeployDeployIdVersionRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/api/app/domeos/deployversion/deploy/{deployId}/{version}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: ['deployId', 'version'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetDomeosDeployversionDeployDeployIdVersion',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [部署=版本详情↗](http://10.19.12.152:8989/project/502/interface/api/29406) 的 **请求函数**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/deployversion/deploy/{deployId}/{version}`
 * @更新时间 `2025-08-18 16:18:15`
 */
const apiGetDomeosDeployversionDeployDeployIdVersion = /*#__PURE__*/ (
  requestData: ApiGetDomeosDeployversionDeployDeployIdVersionRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetDomeosDeployversionDeployDeployIdVersionResponse>(
    prepare(
      apiGetDomeosDeployversionDeployDeployIdVersionRequestConfig,
      requestData
    ),
    ...args
  )
}

apiGetDomeosDeployversionDeployDeployIdVersion.requestConfig =
  apiGetDomeosDeployversionDeployDeployIdVersionRequestConfig

/**
 * 接口 [部署=版本详情↗](http://10.19.12.152:8989/project/502/interface/api/29406) 的 **React Hook**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/deployversion/deploy/{deployId}/{version}`
 * @更新时间 `2025-08-18 16:18:15`
 */
export const useApiGetDomeosDeployversionDeployDeployIdVersion =
  /*#__PURE__*/ makeRequestHook<
    ApiGetDomeosDeployversionDeployDeployIdVersionRequest,
    ApiGetDomeosDeployversionDeployDeployIdVersionRequestConfig,
    ReturnType<typeof apiGetDomeosDeployversionDeployDeployIdVersion>
  >(apiGetDomeosDeployversionDeployDeployIdVersion)

/**
 * 接口 [部署=版本列表↗](http://10.19.12.152:8989/project/502/interface/api/29413) 的 **请求类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/deployversion/deploy/{deployId}`
 * @更新时间 `2025-08-12 16:44:56`
 */
export interface ApiGetDomeosDeployversionDeployDeployIdRequest {
  deployId: string
}

/**
 * 接口 [部署=版本列表↗](http://10.19.12.152:8989/project/502/interface/api/29413) 的 **返回类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/deployversion/deploy/{deployId}`
 * @更新时间 `2025-08-12 16:44:56`
 */
export type ApiGetDomeosDeployversionDeployDeployIdResponse = {
  /**
   * 版本id
   */
  id: number
  /**
   * 版本名称
   */
  name: string
  description: string
  state: string
  /**
   * 创建时间
   */
  createTime: number
  removeTime: number
  removed: boolean
  graceTime: number
  deployId: number
  /**
   * 版本号
   */
  version: number
  podSpecStr: null
  versionType: string
  containers: null
  labelSelectors: null
  hostAliases: null
  hostList: null
  affinityType: null
  nodeAffinityPreferance: null
  nodeAntiAffinityRequired: null
  sysctls: null
  promMetrics: null
  versionPodDNSConfig: null
  sharedHostNS: null
  consulService: null
  traceConfigInfo: null
  flumeLogConfigInfo: null
  lokiLogConfigInfo: null
  traceConfig: null
  lokiLogConfig: null
  istioInjection: boolean
  enableYarnHpa: boolean
  deprecate: boolean
  autoDeploy: boolean
}[]

/**
 * 接口 [部署=版本列表↗](http://10.19.12.152:8989/project/502/interface/api/29413) 的 **请求配置的类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/deployversion/deploy/{deployId}`
 * @更新时间 `2025-08-12 16:44:56`
 */
type ApiGetDomeosDeployversionDeployDeployIdRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/domeos/deployversion/deploy/{deployId}',
    'data',
    'deployId',
    string,
    false
  >
>

/**
 * 接口 [部署=版本列表↗](http://10.19.12.152:8989/project/502/interface/api/29413) 的 **请求配置**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/deployversion/deploy/{deployId}`
 * @更新时间 `2025-08-12 16:44:56`
 */
const apiGetDomeosDeployversionDeployDeployIdRequestConfig: ApiGetDomeosDeployversionDeployDeployIdRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/api/app/domeos/deployversion/deploy/{deployId}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: ['deployId'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetDomeosDeployversionDeployDeployId',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [部署=版本列表↗](http://10.19.12.152:8989/project/502/interface/api/29413) 的 **请求函数**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/deployversion/deploy/{deployId}`
 * @更新时间 `2025-08-12 16:44:56`
 */
const apiGetDomeosDeployversionDeployDeployId = /*#__PURE__*/ (
  requestData: ApiGetDomeosDeployversionDeployDeployIdRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetDomeosDeployversionDeployDeployIdResponse>(
    prepare(apiGetDomeosDeployversionDeployDeployIdRequestConfig, requestData),
    ...args
  )
}

apiGetDomeosDeployversionDeployDeployId.requestConfig =
  apiGetDomeosDeployversionDeployDeployIdRequestConfig

/**
 * 接口 [部署=版本列表↗](http://10.19.12.152:8989/project/502/interface/api/29413) 的 **React Hook**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/deployversion/deploy/{deployId}`
 * @更新时间 `2025-08-12 16:44:56`
 */
export const useApiGetDomeosDeployversionDeployDeployId =
  /*#__PURE__*/ makeRequestHook<
    ApiGetDomeosDeployversionDeployDeployIdRequest,
    ApiGetDomeosDeployversionDeployDeployIdRequestConfig,
    ReturnType<typeof apiGetDomeosDeployversionDeployDeployId>
  >(apiGetDomeosDeployversionDeployDeployId)

/**
 * 接口 [部署=创建版本↗](http://10.19.12.152:8989/project/502/interface/api/29420) 的 **请求类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `POST /api/app/domeos/deployversion`
 * @更新时间 `2025-08-18 14:14:55`
 */
export interface ApiPostDomeosDeployversionRequest {
  id: number
  /**
   * 上一次版本号
   */
  version: number
  /**
   * 版本名
   */
  name: string
  /**
   * 部署id
   */
  deployId: number
  /**
   * 必须主机
   */
  labelSelectors: string[]
  /**
   * 实例强行终止时间
   */
  graceTime: number
  restartPolicy: string
  istioInjection: boolean
  enableYarnHpa: boolean
  hostAliases: string[]
  affinityType: null
  /**
   * 优先主机标签
   */
  nodeAffinityPreferance: string[]
  /**
   * 排除主机标签
   */
  nodeAntiAffinityRequired: string[]
  sysctls: string[]
  promMetrics: null
  versionPodDNSConfig: {
    nameservers: string[]
    searches: string[]
    options: string[]
    desc: number
  }
  sharedHostNS: null
  lokiLogConfigInfo: {
    id: number
    name: string
    serviceName: string
  }
  flumeLogConfigInfo: {
    id: number
    name: string
    serviceName: string
  }
  traceConfigInfo: null
  versionType: string
  containers: {
    /**
     * 部署名
     */
    name: string
    /**
     * NORMAL
     */
    containerType: string
    /**
     * 镜像信息
     */
    imageInfo: {
      /**
       * 地址
       */
      registry: string
      /**
       * 项目/部署名
       */
      name: string
      /**
       * 分支信息（简要）
       */
      tag: string
      /**
       * BUILD
       */
      type: string
    }
    /**
     * 拉取策略
     */
    imagePullPolicy: string
    /**
     * cpu限制
     */
    cpuLimit: number
    /**
     * cpu需求
     */
    cpuRequest: number
    memLimit: number
    memRequest: number
    gpuLimit: number
    gpuRequest: number
    gpuMemLimit: number
    gpuMemRequest: number
    nvshareGpuRequest: number
    nvshareGpuLimit: number
    timeSliceGpuRequest: number
    timeSliceGpuLimit: number
    hamiGpuQuotaLimit: number
    hamiGpuCoresLimit: number
    hamiGpuMemLimit: number
    command: null
    /**
     * 挂载存储
     */
    volumeMounts: {
      /**
       * HOSTPATH
       */
      volumeType: string
      /**
       * 只读
       */
      readonly: boolean
      /**
       * 容器地址
       */
      containerPath: string
      /**
       * 宿主机地址
       */
      hostPath: string
    }[]
    logConfig: number
    lokiLogItems: string[]
    logItems: string[]
    envs: {
      key: string
      value: string
      description: null
    }[]
    /**
     * 配置文件
     */
    configs: string[]
    healthChecker: null
    /**
     * 就绪检查
     */
    readinessChecker: {
      type: string
      port: number
      delay: number
      periodSeconds: number
      timeout: number
      url: null
      failureThreshold: number
      successThreshold: number
    }
    startupChecker: null
    lifecycle: {
      postStart: null
      preStop: null
    }
    /**
     * 自动升级
     */
    autoDeploy: boolean
    securityContext: null
    privileged: boolean
  }[]
}

/**
 * 接口 [部署=创建版本↗](http://10.19.12.152:8989/project/502/interface/api/29420) 的 **返回类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `POST /api/app/domeos/deployversion`
 * @更新时间 `2025-08-18 14:14:55`
 */
export interface ApiPostDomeosDeployversionResponse {
  id?: number
  name?: string
  description?: string
  state?: string
  createTime?: number
  removeTime?: number
  removed?: boolean
  graceTime?: number
  deployId?: number
  /**
   * 最新版本号
   */
  version?: number
  podSpecStr?: null
  versionType?: string
  containers?: {
    name?: string
    envs?: {
      key: string
      value: string
      description: null
    }[]
    command?: null
    enableLxcfs?: boolean
    gpuLimit?: number
    gpuRequest?: number
    gpuMemLimit?: number
    gpuMemRequest?: number
    nvshareGpuLimit?: number
    nvshareGpuRequest?: number
    timeSliceGpuLimit?: number
    timeSliceGpuRequest?: number
    hamiGpuQuotaLimit?: number
    hamiGpuCoresLimit?: number
    hamiGpuMemLimit?: number
    cpuLimit?: number
    cpuRequest?: number
    memLimit?: number
    memRequest?: number
    imageInfo?: {
      registry?: string
      name?: string
      tag?: string
      type?: string
    }
    logItems?: string[]
    lokiLogItems?: string[]
    configs?: string[]
    autoDeploy?: boolean
    healthChecker?: null
    readinessChecker?: {
      port?: number
      delay?: number
      timeout?: number
      failureThreshold?: number
      successThreshold?: number
      periodSeconds?: number
      url?: null
      type?: string
    }
    startupChecker?: null
    volumeMounts?: {
      name: null
      hostPath: string
      emptyDir: null
      volumePVC: null
      containerPath: string
      volumeType: string
      readonly: boolean
      pathType: null
      dynamicVolume: boolean
      cephcsiv1: boolean
      mountPropagation: null
    }[]
    imagePullPolicy?: string
    logConfig?: number
    lifecycle?: {
      postStart?: null
      preStop?: null
    }
    containerType?: string
    securityContext?: null
    privileged?: boolean
  }[]
  labelSelectors?: string[]
  hostAliases?: string[]
  hostList?: null
  affinityType?: null
  nodeAffinityPreferance?: string[]
  nodeAntiAffinityRequired?: string[]
  sysctls?: null
  promMetrics?: null
  versionPodDNSConfig?: {
    nameservers?: string[]
    searches?: string[]
    options?: string[]
    desc?: number
  }
  sharedHostNS?: null
  consulService?: null
  traceConfigInfo?: null
  flumeLogConfigInfo?: {
    id?: number
    name?: string
    serviceName?: string
  }
  lokiLogConfigInfo?: {
    id?: number
    name?: string
    serviceName?: string
  }
  traceConfig?: null
  lokiLogConfig?: null
  istioInjection?: boolean
  enableYarnHpa?: boolean
  deprecate?: boolean
  autoDeploy?: boolean
}

/**
 * 接口 [部署=创建版本↗](http://10.19.12.152:8989/project/502/interface/api/29420) 的 **请求配置的类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `POST /api/app/domeos/deployversion`
 * @更新时间 `2025-08-18 14:14:55`
 */
type ApiPostDomeosDeployversionRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/domeos/deployversion',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [部署=创建版本↗](http://10.19.12.152:8989/project/502/interface/api/29420) 的 **请求配置**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `POST /api/app/domeos/deployversion`
 * @更新时间 `2025-08-18 14:14:55`
 */
const apiPostDomeosDeployversionRequestConfig: ApiPostDomeosDeployversionRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/api/app/domeos/deployversion',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPostDomeosDeployversion',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [部署=创建版本↗](http://10.19.12.152:8989/project/502/interface/api/29420) 的 **请求函数**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `POST /api/app/domeos/deployversion`
 * @更新时间 `2025-08-18 14:14:55`
 */
const apiPostDomeosDeployversion = /*#__PURE__*/ (
  requestData: ApiPostDomeosDeployversionRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPostDomeosDeployversionResponse>(
    prepare(apiPostDomeosDeployversionRequestConfig, requestData),
    ...args
  )
}

apiPostDomeosDeployversion.requestConfig =
  apiPostDomeosDeployversionRequestConfig

/**
 * 接口 [部署=创建版本↗](http://10.19.12.152:8989/project/502/interface/api/29420) 的 **React Hook**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `POST /api/app/domeos/deployversion`
 * @更新时间 `2025-08-18 14:14:55`
 */
export const useApiPostDomeosDeployversion = /*#__PURE__*/ makeRequestHook<
  ApiPostDomeosDeployversionRequest,
  ApiPostDomeosDeployversionRequestConfig,
  ReturnType<typeof apiPostDomeosDeployversion>
>(apiPostDomeosDeployversion)

/**
 * 接口 [资源包=资源包列表↗](http://10.19.12.152:8989/project/502/interface/api/29427) 的 **请求类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/bundle/bundlelist`
 * @更新时间 `2025-08-12 19:09:29`
 */
export interface ApiGetDomeosBundleBundlelistRequest {}

/**
 * 接口 [资源包=资源包列表↗](http://10.19.12.152:8989/project/502/interface/api/29427) 的 **返回类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/bundle/bundlelist`
 * @更新时间 `2025-08-12 19:09:29`
 */
export type ApiGetDomeosBundleBundlelistResponse = {
  /**
   * 资源包id
   */
  id: number
  /**
   * 资源包名称
   */
  name: string
  description: string
  state: string
  createTime: number
  removeTime: number
  removed: boolean
  owner: {
    id: number
    name: string
  }
  clusterId: number
  storageCapacity: number
  nodeInfos: null
  k8sConfig: {
    enableGpu: boolean
    enableHamiGpu: boolean
    enableNvshare: boolean
    enableTimeSliceGpu: boolean
    enableSysctl: boolean
    enableSecurityContext: boolean
    cniCidrs: null
  }
  cpuAllocated: number
  memoryAllocated: number
  ipPoolName: null
  receiveResourceNotify: boolean
  capacity: {
    /**
     * cpu总量
     */
    cpu: number
    /**
     * cpu分配量
     */
    cpuAllocated: number
    /**
     * cpu占比
     */
    cpuAllocatedPercentage: number
    /**
     * 内存总量
     */
    memory: number
    /**
     * 内存分配量
     */
    memoryAllocated: number
    /**
     * 内存占比
     */
    memoryAllocatedPercentage: number
    gpu: number
    gpuAllocated: number
    gpuAllocatedPercentage: string | number
    gpuMem: number
    gpuMemAllocated: number
    gpuMemAllocatedPercentage: string | number
  }
  role: null
}[]

/**
 * 接口 [资源包=资源包列表↗](http://10.19.12.152:8989/project/502/interface/api/29427) 的 **请求配置的类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/bundle/bundlelist`
 * @更新时间 `2025-08-12 19:09:29`
 */
type ApiGetDomeosBundleBundlelistRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/domeos/bundle/bundlelist',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [资源包=资源包列表↗](http://10.19.12.152:8989/project/502/interface/api/29427) 的 **请求配置**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/bundle/bundlelist`
 * @更新时间 `2025-08-12 19:09:29`
 */
const apiGetDomeosBundleBundlelistRequestConfig: ApiGetDomeosBundleBundlelistRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/api/app/domeos/bundle/bundlelist',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetDomeosBundleBundlelist',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [资源包=资源包列表↗](http://10.19.12.152:8989/project/502/interface/api/29427) 的 **请求函数**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/bundle/bundlelist`
 * @更新时间 `2025-08-12 19:09:29`
 */
const apiGetDomeosBundleBundlelist = /*#__PURE__*/ (
  requestData?: ApiGetDomeosBundleBundlelistRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetDomeosBundleBundlelistResponse>(
    prepare(apiGetDomeosBundleBundlelistRequestConfig, requestData),
    ...args
  )
}

apiGetDomeosBundleBundlelist.requestConfig =
  apiGetDomeosBundleBundlelistRequestConfig

/**
 * 接口 [资源包=资源包列表↗](http://10.19.12.152:8989/project/502/interface/api/29427) 的 **React Hook**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/bundle/bundlelist`
 * @更新时间 `2025-08-12 19:09:29`
 */
export const useApiGetDomeosBundleBundlelist = /*#__PURE__*/ makeRequestHook<
  ApiGetDomeosBundleBundlelistRequest,
  ApiGetDomeosBundleBundlelistRequestConfig,
  ReturnType<typeof apiGetDomeosBundleBundlelist>
>(apiGetDomeosBundleBundlelist)

/**
 * 接口 [资源包=资源包详情（包括主机列表）↗](http://10.19.12.152:8989/project/502/interface/api/29434) 的 **请求类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/bundle/{bundleId}`
 * @更新时间 `2025-08-12 16:50:59`
 */
export interface ApiGetDomeosBundleBundleIdRequest {
  bundleId: string
}

/**
 * 接口 [资源包=资源包详情（包括主机列表）↗](http://10.19.12.152:8989/project/502/interface/api/29434) 的 **返回类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/bundle/{bundleId}`
 * @更新时间 `2025-08-12 16:50:59`
 */
export interface ApiGetDomeosBundleBundleIdResponse {
  id: number
  name: string
  description: string
  state: string
  createTime: number
  removeTime: number
  removed: boolean
  owner: {
    id: number
    name: string
  }
  clusterId: number
  storageCapacity: number
  /**
   * 主机列表数据
   */
  nodeInfos: {
    /**
     * 主机名称
     */
    name: string
    /**
     * 主机ip
     */
    ip: string
    labels: null
    capacity: {
      cpu: number
      cpuAllocated: number
      cpuAllocatedPercentage: number
      memory: number
      memoryAllocated: number
      memoryAllocatedPercentage: number
      gpu: number
      gpuAllocated: number
      gpuAllocatedPercentage: string
      gpuMem: number
      gpuMemAllocated: number
      gpuMemAllocatedPercentage: string
    }
    runningInstances: number
    /**
     * 状态
     */
    status: string
    unschedulable: number
    createTime: number
    dockerVersion: string
    kubeletVersion: string
    kernelVersion: string
    osVersion: string
    networkIP: number
    userLabels: string[]
    userTaint: null
    topologyZone: null
    bundleInfo: {
      id: number
      name: null
    }
    clusterInfo: null
    machineId: number
    attribution: null
    networkIpLinkDeployCount: number
    idle: boolean
  }[]
  k8sConfig: {
    enableGpu: boolean
    enableHamiGpu: boolean
    enableNvshare: boolean
    enableTimeSliceGpu: boolean
    enableSysctl: boolean
    enableSecurityContext: boolean
    cniCidrs: null
  }
  cpuAllocated: number
  memoryAllocated: number
  ipPoolName: null
  receiveResourceNotify: boolean
  capacity: {
    cpu: number
    cpuAllocated: number
    cpuAllocatedPercentage: number
    memory: number
    memoryAllocated: number
    memoryAllocatedPercentage: number
    gpu: number
    gpuAllocated: number
    gpuAllocatedPercentage: string
    gpuMem: number
    gpuMemAllocated: number
    gpuMemAllocatedPercentage: string
  }
  role: string
}

/**
 * 接口 [资源包=资源包详情（包括主机列表）↗](http://10.19.12.152:8989/project/502/interface/api/29434) 的 **请求配置的类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/bundle/{bundleId}`
 * @更新时间 `2025-08-12 16:50:59`
 */
type ApiGetDomeosBundleBundleIdRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/domeos/bundle/{bundleId}',
    'data',
    'bundleId',
    string,
    false
  >
>

/**
 * 接口 [资源包=资源包详情（包括主机列表）↗](http://10.19.12.152:8989/project/502/interface/api/29434) 的 **请求配置**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/bundle/{bundleId}`
 * @更新时间 `2025-08-12 16:50:59`
 */
const apiGetDomeosBundleBundleIdRequestConfig: ApiGetDomeosBundleBundleIdRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/api/app/domeos/bundle/{bundleId}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: ['bundleId'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetDomeosBundleBundleId',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [资源包=资源包详情（包括主机列表）↗](http://10.19.12.152:8989/project/502/interface/api/29434) 的 **请求函数**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/bundle/{bundleId}`
 * @更新时间 `2025-08-12 16:50:59`
 */
const apiGetDomeosBundleBundleId = /*#__PURE__*/ (
  requestData: ApiGetDomeosBundleBundleIdRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetDomeosBundleBundleIdResponse>(
    prepare(apiGetDomeosBundleBundleIdRequestConfig, requestData),
    ...args
  )
}

apiGetDomeosBundleBundleId.requestConfig =
  apiGetDomeosBundleBundleIdRequestConfig

/**
 * 接口 [资源包=资源包详情（包括主机列表）↗](http://10.19.12.152:8989/project/502/interface/api/29434) 的 **React Hook**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `GET /api/app/domeos/bundle/{bundleId}`
 * @更新时间 `2025-08-12 16:50:59`
 */
export const useApiGetDomeosBundleBundleId = /*#__PURE__*/ makeRequestHook<
  ApiGetDomeosBundleBundleIdRequest,
  ApiGetDomeosBundleBundleIdRequestConfig,
  ReturnType<typeof apiGetDomeosBundleBundleId>
>(apiGetDomeosBundleBundleId)

/**
 * 接口 [资源包=停用主机\/启用主机↗](http://10.19.12.152:8989/project/502/interface/api/29441) 的 **请求类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `POST /api/app/domeos/bundle/{clusterId}/{operation}`
 * @更新时间 `2025-08-29 16:33:12`
 */
export interface ApiPostDomeosBundleClusterIdOperationRequest {
  /**
   * 主机名
   */
  name?: string
  /**
   * 主机ip
   */
  ip?: string
  /**
   * 集群Id
   */
  clusterId: string
  /**
   * 操作类型：drain: 停用 ； recovery: 启用
   */
  operation: string
}

/**
 * 接口 [资源包=停用主机\/启用主机↗](http://10.19.12.152:8989/project/502/interface/api/29441) 的 **返回类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `POST /api/app/domeos/bundle/{clusterId}/{operation}`
 * @更新时间 `2025-08-29 16:33:12`
 */
export interface ApiPostDomeosBundleClusterIdOperationResponse {}

/**
 * 接口 [资源包=停用主机\/启用主机↗](http://10.19.12.152:8989/project/502/interface/api/29441) 的 **请求配置的类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `POST /api/app/domeos/bundle/{clusterId}/{operation}`
 * @更新时间 `2025-08-29 16:33:12`
 */
type ApiPostDomeosBundleClusterIdOperationRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/domeos/bundle/{clusterId}/{operation}',
    'data',
    'clusterId' | 'operation',
    string,
    false
  >
>

/**
 * 接口 [资源包=停用主机\/启用主机↗](http://10.19.12.152:8989/project/502/interface/api/29441) 的 **请求配置**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `POST /api/app/domeos/bundle/{clusterId}/{operation}`
 * @更新时间 `2025-08-29 16:33:12`
 */
const apiPostDomeosBundleClusterIdOperationRequestConfig: ApiPostDomeosBundleClusterIdOperationRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/api/app/domeos/bundle/{clusterId}/{operation}',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: ['clusterId', 'operation'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPostDomeosBundleClusterIdOperation',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [资源包=停用主机\/启用主机↗](http://10.19.12.152:8989/project/502/interface/api/29441) 的 **请求函数**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `POST /api/app/domeos/bundle/{clusterId}/{operation}`
 * @更新时间 `2025-08-29 16:33:12`
 */
const apiPostDomeosBundleClusterIdOperation = /*#__PURE__*/ (
  requestData: ApiPostDomeosBundleClusterIdOperationRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPostDomeosBundleClusterIdOperationResponse>(
    prepare(apiPostDomeosBundleClusterIdOperationRequestConfig, requestData),
    ...args
  )
}

apiPostDomeosBundleClusterIdOperation.requestConfig =
  apiPostDomeosBundleClusterIdOperationRequestConfig

/**
 * 接口 [资源包=停用主机\/启用主机↗](http://10.19.12.152:8989/project/502/interface/api/29441) 的 **React Hook**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @请求头 `POST /api/app/domeos/bundle/{clusterId}/{operation}`
 * @更新时间 `2025-08-29 16:33:12`
 */
export const useApiPostDomeosBundleClusterIdOperation =
  /*#__PURE__*/ makeRequestHook<
    ApiPostDomeosBundleClusterIdOperationRequest,
    ApiPostDomeosBundleClusterIdOperationRequestConfig,
    ReturnType<typeof apiPostDomeosBundleClusterIdOperation>
  >(apiPostDomeosBundleClusterIdOperation)

/**
 * 接口 [资源包=主机信息（详情+标签）↗](http://10.19.12.152:8989/project/502/interface/api/29448) 的 **请求类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/bundle/nodeinfobyclusterid/{clusterId}/node/{nodeName}/`
 * @更新时间 `2025-08-18 14:14:56`
 */
export interface ApiGetDomeosBundleNodeinfobyclusteridClusterIdNodeNodeNameRequest {
  clusterId: string
  nodeName: string
}

/**
 * 接口 [资源包=主机信息（详情+标签）↗](http://10.19.12.152:8989/project/502/interface/api/29448) 的 **返回类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/bundle/nodeinfobyclusterid/{clusterId}/node/{nodeName}/`
 * @更新时间 `2025-08-18 14:14:56`
 */
export interface ApiGetDomeosBundleNodeinfobyclusteridClusterIdNodeNodeNameResponse {
  /**
   * 主机名称
   */
  name: string
  /**
   * 主机ip
   */
  ip: string
  labels: null
  capacity: {
    /**
     * 总
     */
    cpu: number
    /**
     * 分配
     */
    cpuAllocated: number
    /**
     * 占比
     */
    cpuAllocatedPercentage: number
    memory: number
    memoryAllocated: number
    memoryAllocatedPercentage: number
    gpu: number
    gpuAllocated: number
    gpuAllocatedPercentage: number
    gpuMem: number
    gpuMemAllocated: number
    gpuMemAllocatedPercentage: number
  }
  runningInstances: number
  status: string
  unschedulable: number
  createTime: number
  /**
   * Docker版本
   */
  dockerVersion: string
  /**
   * Kubelet 版本
   */
  kubeletVersion: string
  kernelVersion: string
  /**
   * 操作系统
   */
  osVersion: string
  networkIP: number
  /**
   * 主机变迁
   */
  userLabels: string[]
  userTaint: null
  topologyZone: null
  bundleInfo: {
    id: number
    name: string
  }
  clusterInfo: {
    id: number
    name: string
  }
  machineId: number
  attribution: string
  networkIpLinkDeployCount: number
  idle: boolean
}

/**
 * 接口 [资源包=主机信息（详情+标签）↗](http://10.19.12.152:8989/project/502/interface/api/29448) 的 **请求配置的类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/bundle/nodeinfobyclusterid/{clusterId}/node/{nodeName}/`
 * @更新时间 `2025-08-18 14:14:56`
 */
type ApiGetDomeosBundleNodeinfobyclusteridClusterIdNodeNodeNameRequestConfig =
  Readonly<
    RequestConfig<
      'http://10.19.12.152:8989/mock/502',
      '',
      '',
      '/api/app/domeos/bundle/nodeinfobyclusterid/{clusterId}/node/{nodeName}/',
      'data',
      'clusterId' | 'nodeName',
      string,
      false
    >
  >

/**
 * 接口 [资源包=主机信息（详情+标签）↗](http://10.19.12.152:8989/project/502/interface/api/29448) 的 **请求配置**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/bundle/nodeinfobyclusterid/{clusterId}/node/{nodeName}/`
 * @更新时间 `2025-08-18 14:14:56`
 */
const apiGetDomeosBundleNodeinfobyclusteridClusterIdNodeNodeNameRequestConfig: ApiGetDomeosBundleNodeinfobyclusteridClusterIdNodeNodeNameRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/api/app/domeos/bundle/nodeinfobyclusterid/{clusterId}/node/{nodeName}/',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: ['clusterId', 'nodeName'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiGetDomeosBundleNodeinfobyclusteridClusterIdNodeNodeName',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [资源包=主机信息（详情+标签）↗](http://10.19.12.152:8989/project/502/interface/api/29448) 的 **请求函数**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/bundle/nodeinfobyclusterid/{clusterId}/node/{nodeName}/`
 * @更新时间 `2025-08-18 14:14:56`
 */
const apiGetDomeosBundleNodeinfobyclusteridClusterIdNodeNodeName =
  /*#__PURE__*/ (
    requestData: ApiGetDomeosBundleNodeinfobyclusteridClusterIdNodeNodeNameRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiGetDomeosBundleNodeinfobyclusteridClusterIdNodeNodeNameResponse>(
      prepare(
        apiGetDomeosBundleNodeinfobyclusteridClusterIdNodeNodeNameRequestConfig,
        requestData
      ),
      ...args
    )
  }

apiGetDomeosBundleNodeinfobyclusteridClusterIdNodeNodeName.requestConfig =
  apiGetDomeosBundleNodeinfobyclusteridClusterIdNodeNodeNameRequestConfig

/**
 * 接口 [资源包=主机信息（详情+标签）↗](http://10.19.12.152:8989/project/502/interface/api/29448) 的 **React Hook**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/bundle/nodeinfobyclusterid/{clusterId}/node/{nodeName}/`
 * @更新时间 `2025-08-18 14:14:56`
 */
export const useApiGetDomeosBundleNodeinfobyclusteridClusterIdNodeNodeName =
  /*#__PURE__*/ makeRequestHook<
    ApiGetDomeosBundleNodeinfobyclusteridClusterIdNodeNodeNameRequest,
    ApiGetDomeosBundleNodeinfobyclusteridClusterIdNodeNodeNameRequestConfig,
    ReturnType<
      typeof apiGetDomeosBundleNodeinfobyclusteridClusterIdNodeNodeName
    >
  >(apiGetDomeosBundleNodeinfobyclusteridClusterIdNodeNodeName)

/**
 * 接口 [资源包=主机监控\/部署监控↗](http://10.19.12.152:8989/project/502/interface/api/29455) 的 **请求类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/ws/monitor`
 * @更新时间 `2025-08-27 18:04:54`
 */
export interface ApiGetDomeosWsMonitorRequest {
  /**
   * DEPLOY: 部署监控 ； NODE; 主机监控
   */
  type: string
  startTime: string
  endTime: string
  realTime: string
  /**
   * 27118  部署id； jsy-11-115 主机名
   */
  queryId: string
}

/**
 * 接口 [资源包=主机监控\/部署监控↗](http://10.19.12.152:8989/project/502/interface/api/29455) 的 **返回类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/ws/monitor`
 * @更新时间 `2025-08-27 18:04:54`
 */
export type ApiGetDomeosWsMonitorResponse = {
  /**
   * 监控指标
   */
  monitorItem: string
  /**
   * 监控指标中文
   */
  monitorName: string
  /**
   * 单位
   */
  unit: string
  items: {
    dataTimeStamp: {
      /**
       * 时间戳
       */
      timestamp: number
      /**
       * 指标值
       */
      value: number
    }[]
    /**
     * 监控名
     */
    name: string
  }[]
}[]

/**
 * 接口 [资源包=主机监控\/部署监控↗](http://10.19.12.152:8989/project/502/interface/api/29455) 的 **请求配置的类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/ws/monitor`
 * @更新时间 `2025-08-27 18:04:54`
 */
type ApiGetDomeosWsMonitorRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/domeos/ws/monitor',
    'data',
    string,
    'type' | 'startTime' | 'endTime' | 'realTime' | 'queryId',
    false
  >
>

/**
 * 接口 [资源包=主机监控\/部署监控↗](http://10.19.12.152:8989/project/502/interface/api/29455) 的 **请求配置**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/ws/monitor`
 * @更新时间 `2025-08-27 18:04:54`
 */
const apiGetDomeosWsMonitorRequestConfig: ApiGetDomeosWsMonitorRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/api/app/domeos/ws/monitor',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: [],
    queryNames: ['type', 'startTime', 'endTime', 'realTime', 'queryId'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetDomeosWsMonitor',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [资源包=主机监控\/部署监控↗](http://10.19.12.152:8989/project/502/interface/api/29455) 的 **请求函数**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/ws/monitor`
 * @更新时间 `2025-08-27 18:04:54`
 */
const apiGetDomeosWsMonitor = /*#__PURE__*/ (
  requestData: ApiGetDomeosWsMonitorRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetDomeosWsMonitorResponse>(
    prepare(apiGetDomeosWsMonitorRequestConfig, requestData),
    ...args
  )
}

apiGetDomeosWsMonitor.requestConfig = apiGetDomeosWsMonitorRequestConfig

/**
 * 接口 [资源包=主机监控\/部署监控↗](http://10.19.12.152:8989/project/502/interface/api/29455) 的 **React Hook**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/ws/monitor`
 * @更新时间 `2025-08-27 18:04:54`
 */
export const useApiGetDomeosWsMonitor = /*#__PURE__*/ makeRequestHook<
  ApiGetDomeosWsMonitorRequest,
  ApiGetDomeosWsMonitorRequestConfig,
  ReturnType<typeof apiGetDomeosWsMonitor>
>(apiGetDomeosWsMonitor)

/**
 * 接口 [资源包=可选标签列表↗](http://10.19.12.152:8989/project/502/interface/api/29469) 的 **请求类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/bundle/labelmap/{bundleId}`
 * @更新时间 `2025-08-27 15:21:35`
 */
export interface ApiGetDomeosBundleLabelmapBundleIdRequest {
  bundleId: string
}

/**
 * 接口 [资源包=可选标签列表↗](http://10.19.12.152:8989/project/502/interface/api/29469) 的 **返回类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/bundle/labelmap/{bundleId}`
 * @更新时间 `2025-08-27 15:21:35`
 */
export type ApiGetDomeosBundleLabelmapBundleIdResponse = {
  /**
   * 标签名
   */
  name: string
  /**
   * 指定该标签的部署
   */
  deployInfo: {
    resourceType: string
    /**
     * 部署信息
     */
    baseInfo: {
      /**
       * 部署id
       */
      id: number
      /**
       * 部署名
       */
      name: string
    }
  }[]
}[]

/**
 * 接口 [资源包=可选标签列表↗](http://10.19.12.152:8989/project/502/interface/api/29469) 的 **请求配置的类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/bundle/labelmap/{bundleId}`
 * @更新时间 `2025-08-27 15:21:35`
 */
type ApiGetDomeosBundleLabelmapBundleIdRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/domeos/bundle/labelmap/{bundleId}',
    'data',
    'bundleId',
    string,
    false
  >
>

/**
 * 接口 [资源包=可选标签列表↗](http://10.19.12.152:8989/project/502/interface/api/29469) 的 **请求配置**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/bundle/labelmap/{bundleId}`
 * @更新时间 `2025-08-27 15:21:35`
 */
const apiGetDomeosBundleLabelmapBundleIdRequestConfig: ApiGetDomeosBundleLabelmapBundleIdRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/api/app/domeos/bundle/labelmap/{bundleId}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: ['bundleId'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetDomeosBundleLabelmapBundleId',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [资源包=可选标签列表↗](http://10.19.12.152:8989/project/502/interface/api/29469) 的 **请求函数**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/bundle/labelmap/{bundleId}`
 * @更新时间 `2025-08-27 15:21:35`
 */
const apiGetDomeosBundleLabelmapBundleId = /*#__PURE__*/ (
  requestData: ApiGetDomeosBundleLabelmapBundleIdRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetDomeosBundleLabelmapBundleIdResponse>(
    prepare(apiGetDomeosBundleLabelmapBundleIdRequestConfig, requestData),
    ...args
  )
}

apiGetDomeosBundleLabelmapBundleId.requestConfig =
  apiGetDomeosBundleLabelmapBundleIdRequestConfig

/**
 * 接口 [资源包=可选标签列表↗](http://10.19.12.152:8989/project/502/interface/api/29469) 的 **React Hook**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/bundle/labelmap/{bundleId}`
 * @更新时间 `2025-08-27 15:21:35`
 */
export const useApiGetDomeosBundleLabelmapBundleId =
  /*#__PURE__*/ makeRequestHook<
    ApiGetDomeosBundleLabelmapBundleIdRequest,
    ApiGetDomeosBundleLabelmapBundleIdRequestConfig,
    ReturnType<typeof apiGetDomeosBundleLabelmapBundleId>
  >(apiGetDomeosBundleLabelmapBundleId)

/**
 * 接口 [资源包=标签更新（添加，删除）↗](http://10.19.12.152:8989/project/502/interface/api/29476) 的 **请求类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `POST /api/app/domeos/bundle/setLabel/{bundleId}`
 * @更新时间 `2025-09-16 16:37:57`
 */
export interface ApiPostDomeosBundleSetLabelBundleIdRequest {
  tags?: {
    node: string
    labels: string[]
  }[]
  bundleId: string
}

/**
 * 接口 [资源包=标签更新（添加，删除）↗](http://10.19.12.152:8989/project/502/interface/api/29476) 的 **返回类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `POST /api/app/domeos/bundle/setLabel/{bundleId}`
 * @更新时间 `2025-09-16 16:37:57`
 */
export interface ApiPostDomeosBundleSetLabelBundleIdResponse {}

/**
 * 接口 [资源包=标签更新（添加，删除）↗](http://10.19.12.152:8989/project/502/interface/api/29476) 的 **请求配置的类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `POST /api/app/domeos/bundle/setLabel/{bundleId}`
 * @更新时间 `2025-09-16 16:37:57`
 */
type ApiPostDomeosBundleSetLabelBundleIdRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/domeos/bundle/setLabel/{bundleId}',
    'data',
    'bundleId',
    string,
    false
  >
>

/**
 * 接口 [资源包=标签更新（添加，删除）↗](http://10.19.12.152:8989/project/502/interface/api/29476) 的 **请求配置**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `POST /api/app/domeos/bundle/setLabel/{bundleId}`
 * @更新时间 `2025-09-16 16:37:57`
 */
const apiPostDomeosBundleSetLabelBundleIdRequestConfig: ApiPostDomeosBundleSetLabelBundleIdRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/api/app/domeos/bundle/setLabel/{bundleId}',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: ['bundleId'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPostDomeosBundleSetLabelBundleId',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [资源包=标签更新（添加，删除）↗](http://10.19.12.152:8989/project/502/interface/api/29476) 的 **请求函数**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `POST /api/app/domeos/bundle/setLabel/{bundleId}`
 * @更新时间 `2025-09-16 16:37:57`
 */
const apiPostDomeosBundleSetLabelBundleId = /*#__PURE__*/ (
  requestData: ApiPostDomeosBundleSetLabelBundleIdRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPostDomeosBundleSetLabelBundleIdResponse>(
    prepare(apiPostDomeosBundleSetLabelBundleIdRequestConfig, requestData),
    ...args
  )
}

apiPostDomeosBundleSetLabelBundleId.requestConfig =
  apiPostDomeosBundleSetLabelBundleIdRequestConfig

/**
 * 接口 [资源包=标签更新（添加，删除）↗](http://10.19.12.152:8989/project/502/interface/api/29476) 的 **React Hook**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `POST /api/app/domeos/bundle/setLabel/{bundleId}`
 * @更新时间 `2025-09-16 16:37:57`
 */
export const useApiPostDomeosBundleSetLabelBundleId =
  /*#__PURE__*/ makeRequestHook<
    ApiPostDomeosBundleSetLabelBundleIdRequest,
    ApiPostDomeosBundleSetLabelBundleIdRequestConfig,
    ReturnType<typeof apiPostDomeosBundleSetLabelBundleId>
  >(apiPostDomeosBundleSetLabelBundleId)

/**
 * 接口 [部署=当前部署版本升级信息↗](http://10.19.12.152:8989/project/502/interface/api/29511) 的 **请求类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/deploy/{deployId}/newestsnapshot`
 * @更新时间 `2025-08-18 14:15:00`
 */
export interface ApiGetDomeosDeployDeployIdNewestsnapshotRequest {
  deployId: string
}

/**
 * 接口 [部署=当前部署版本升级信息↗](http://10.19.12.152:8989/project/502/interface/api/29511) 的 **返回类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/deploy/{deployId}/newestsnapshot`
 * @更新时间 `2025-08-18 14:15:00`
 */
export type ApiGetDomeosDeployDeployIdNewestsnapshotResponse = {
  /**
   * 当前版本号
   */
  version: number
  /**
   * 版本明
   */
  versionName: string
  /**
   * 实例数
   */
  replicas: number
  /**
   * 策略
   */
  policy: {
    /**
     * 最大无效实例数量
     */
    maxUnavailable: number
    /**
     * 最大超额实例数量
     */
    maxSurge: number
    /**
     * 实例升级实际间隔
     */
    minReadySeconds: number
  }
  /**
   * k8s 部署名
   */
  k8sDeployName: string
  horizontalPodAutoScale: {
    hpaRuleId: number
    hpaRuleName: null
    type: null
    minReplicas: number
    maxReplicas: number
    targetCPUPercentage: number
  }
}[]

/**
 * 接口 [部署=当前部署版本升级信息↗](http://10.19.12.152:8989/project/502/interface/api/29511) 的 **请求配置的类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/deploy/{deployId}/newestsnapshot`
 * @更新时间 `2025-08-18 14:15:00`
 */
type ApiGetDomeosDeployDeployIdNewestsnapshotRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/domeos/deploy/{deployId}/newestsnapshot',
    'data',
    'deployId',
    string,
    false
  >
>

/**
 * 接口 [部署=当前部署版本升级信息↗](http://10.19.12.152:8989/project/502/interface/api/29511) 的 **请求配置**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/deploy/{deployId}/newestsnapshot`
 * @更新时间 `2025-08-18 14:15:00`
 */
const apiGetDomeosDeployDeployIdNewestsnapshotRequestConfig: ApiGetDomeosDeployDeployIdNewestsnapshotRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/api/app/domeos/deploy/{deployId}/newestsnapshot',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: ['deployId'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetDomeosDeployDeployIdNewestsnapshot',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [部署=当前部署版本升级信息↗](http://10.19.12.152:8989/project/502/interface/api/29511) 的 **请求函数**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/deploy/{deployId}/newestsnapshot`
 * @更新时间 `2025-08-18 14:15:00`
 */
const apiGetDomeosDeployDeployIdNewestsnapshot = /*#__PURE__*/ (
  requestData: ApiGetDomeosDeployDeployIdNewestsnapshotRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetDomeosDeployDeployIdNewestsnapshotResponse>(
    prepare(apiGetDomeosDeployDeployIdNewestsnapshotRequestConfig, requestData),
    ...args
  )
}

apiGetDomeosDeployDeployIdNewestsnapshot.requestConfig =
  apiGetDomeosDeployDeployIdNewestsnapshotRequestConfig

/**
 * 接口 [部署=当前部署版本升级信息↗](http://10.19.12.152:8989/project/502/interface/api/29511) 的 **React Hook**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/deploy/{deployId}/newestsnapshot`
 * @更新时间 `2025-08-18 14:15:00`
 */
export const useApiGetDomeosDeployDeployIdNewestsnapshot =
  /*#__PURE__*/ makeRequestHook<
    ApiGetDomeosDeployDeployIdNewestsnapshotRequest,
    ApiGetDomeosDeployDeployIdNewestsnapshotRequestConfig,
    ReturnType<typeof apiGetDomeosDeployDeployIdNewestsnapshot>
  >(apiGetDomeosDeployDeployIdNewestsnapshot)

/**
 * 接口 [部署=创建版本时可选镜像↗](http://10.19.12.152:8989/project/502/interface/api/29518) 的 **请求类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/image/detail`
 * @更新时间 `2025-08-18 14:15:03`
 */
export interface ApiGetDomeosImageDetailRequest {
  /**
   * 工程名
   */
  name: string
}

/**
 * 接口 [部署=创建版本时可选镜像↗](http://10.19.12.152:8989/project/502/interface/api/29518) 的 **返回类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/image/detail`
 * @更新时间 `2025-08-18 14:15:03`
 */
export interface ApiGetDomeosImageDetailResponse {
  /**
   * 注册地址
   */
  registry: string
  /**
   * 工程名
   */
  name: string
  /**
   * 镜像标签
   */
  tags: {
    /**
     * 镜像tag
     */
    tag: string
    size: number
    downloadCount: number
    downloadUrl: string
    dockerfileUrl: string
    lastModified: number
    /**
     * 创建时间
     */
    createTime: number
  }[]
  size: number
  downloadCount: number
  /**
   * 上次更新时间
   */
  lastModified: number
  /**
   * 工程创建时间
   */
  createTime: number
  iconUrl: string
  downloadUrl: string
  readMeUrl: string
  projectInfo: string
}

/**
 * 接口 [部署=创建版本时可选镜像↗](http://10.19.12.152:8989/project/502/interface/api/29518) 的 **请求配置的类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/image/detail`
 * @更新时间 `2025-08-18 14:15:03`
 */
type ApiGetDomeosImageDetailRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/domeos/image/detail',
    'data',
    string,
    'name',
    false
  >
>

/**
 * 接口 [部署=创建版本时可选镜像↗](http://10.19.12.152:8989/project/502/interface/api/29518) 的 **请求配置**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/image/detail`
 * @更新时间 `2025-08-18 14:15:03`
 */
const apiGetDomeosImageDetailRequestConfig: ApiGetDomeosImageDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/api/app/domeos/image/detail',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: [],
    queryNames: ['name'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetDomeosImageDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [部署=创建版本时可选镜像↗](http://10.19.12.152:8989/project/502/interface/api/29518) 的 **请求函数**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/image/detail`
 * @更新时间 `2025-08-18 14:15:03`
 */
const apiGetDomeosImageDetail = /*#__PURE__*/ (
  requestData: ApiGetDomeosImageDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetDomeosImageDetailResponse>(
    prepare(apiGetDomeosImageDetailRequestConfig, requestData),
    ...args
  )
}

apiGetDomeosImageDetail.requestConfig = apiGetDomeosImageDetailRequestConfig

/**
 * 接口 [部署=创建版本时可选镜像↗](http://10.19.12.152:8989/project/502/interface/api/29518) 的 **React Hook**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/image/detail`
 * @更新时间 `2025-08-18 14:15:03`
 */
export const useApiGetDomeosImageDetail = /*#__PURE__*/ makeRequestHook<
  ApiGetDomeosImageDetailRequest,
  ApiGetDomeosImageDetailRequestConfig,
  ReturnType<typeof apiGetDomeosImageDetail>
>(apiGetDomeosImageDetail)

/**
 * 接口 [部署-项目列表↗](http://10.19.12.152:8989/project/502/interface/api/29532) 的 **请求类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/projectcollection`
 * @更新时间 `2025-08-18 14:15:02`
 */
export interface ApiGetDomeosProjectcollectionRequest {}

/**
 * 接口 [部署-项目列表↗](http://10.19.12.152:8989/project/502/interface/api/29532) 的 **返回类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/projectcollection`
 * @更新时间 `2025-08-18 14:15:02`
 */
export type ApiGetDomeosProjectcollectionResponse = {
  /**
   * 项目id
   */
  id: number
  /**
   * 项目名
   */
  name: string
  /**
   * 描述
   */
  description: string
  state: string
  /**
   * 创建时间
   */
  createTime: number
  /**
   * 0
   */
  removeTime: number
  removed: boolean
  /**
   * 创建人id
   */
  creatorId: number
  /**
   * PRIVATE: 我的项目；PUBLIC: 公有项目
   */
  projectCollectionState: string
  forbiddenPushWithoutDockerFile: boolean
  /**
   * 成员数量
   */
  memberCount: number
  /**
   * 工程数量
   */
  projectCount: number
  creator: {
    id: number
    name: string
  }
  /**
   * 用户角色：MASTER；DEVELOPER;GUEST
   */
  role: string
}[]

/**
 * 接口 [部署-项目列表↗](http://10.19.12.152:8989/project/502/interface/api/29532) 的 **请求配置的类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/projectcollection`
 * @更新时间 `2025-08-18 14:15:02`
 */
type ApiGetDomeosProjectcollectionRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/domeos/projectcollection',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [部署-项目列表↗](http://10.19.12.152:8989/project/502/interface/api/29532) 的 **请求配置**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/projectcollection`
 * @更新时间 `2025-08-18 14:15:02`
 */
const apiGetDomeosProjectcollectionRequestConfig: ApiGetDomeosProjectcollectionRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/api/app/domeos/projectcollection',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetDomeosProjectcollection',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [部署-项目列表↗](http://10.19.12.152:8989/project/502/interface/api/29532) 的 **请求函数**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/projectcollection`
 * @更新时间 `2025-08-18 14:15:02`
 */
const apiGetDomeosProjectcollection = /*#__PURE__*/ (
  requestData?: ApiGetDomeosProjectcollectionRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetDomeosProjectcollectionResponse>(
    prepare(apiGetDomeosProjectcollectionRequestConfig, requestData),
    ...args
  )
}

apiGetDomeosProjectcollection.requestConfig =
  apiGetDomeosProjectcollectionRequestConfig

/**
 * 接口 [部署-项目列表↗](http://10.19.12.152:8989/project/502/interface/api/29532) 的 **React Hook**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/projectcollection`
 * @更新时间 `2025-08-18 14:15:02`
 */
export const useApiGetDomeosProjectcollection = /*#__PURE__*/ makeRequestHook<
  ApiGetDomeosProjectcollectionRequest,
  ApiGetDomeosProjectcollectionRequestConfig,
  ReturnType<typeof apiGetDomeosProjectcollection>
>(apiGetDomeosProjectcollection)

/**
 * 接口 [部署-项目详情↗](http://10.19.12.152:8989/project/502/interface/api/29539) 的 **请求类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/projectcollection/{projectCollectionId}`
 * @更新时间 `2025-08-18 14:15:05`
 */
export interface ApiGetDomeosProjectcollectionProjectCollectionIdRequest {
  projectCollectionId: string
}

/**
 * 接口 [部署-项目详情↗](http://10.19.12.152:8989/project/502/interface/api/29539) 的 **返回类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/projectcollection/{projectCollectionId}`
 * @更新时间 `2025-08-18 14:15:05`
 */
export interface ApiGetDomeosProjectcollectionProjectCollectionIdResponse {
  /**
   * 项目id
   */
  id: number
  /**
   * 项目名
   */
  name: string
  description: string
  state: string
  createTime: number
  removeTime: number
  removed: boolean
  creatorId: number
  /**
   * PRIVATE;  PUBLIC
   */
  projectCollectionState: string
  forbiddenPushWithoutDockerFile: boolean
  memberCount: number
  projectCount: number
  creator: {
    id: number
    name: string
  }
  role: string
}

/**
 * 接口 [部署-项目详情↗](http://10.19.12.152:8989/project/502/interface/api/29539) 的 **请求配置的类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/projectcollection/{projectCollectionId}`
 * @更新时间 `2025-08-18 14:15:05`
 */
type ApiGetDomeosProjectcollectionProjectCollectionIdRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/domeos/projectcollection/{projectCollectionId}',
    'data',
    'projectCollectionId',
    string,
    false
  >
>

/**
 * 接口 [部署-项目详情↗](http://10.19.12.152:8989/project/502/interface/api/29539) 的 **请求配置**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/projectcollection/{projectCollectionId}`
 * @更新时间 `2025-08-18 14:15:05`
 */
const apiGetDomeosProjectcollectionProjectCollectionIdRequestConfig: ApiGetDomeosProjectcollectionProjectCollectionIdRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/api/app/domeos/projectcollection/{projectCollectionId}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: ['projectCollectionId'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetDomeosProjectcollectionProjectCollectionId',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [部署-项目详情↗](http://10.19.12.152:8989/project/502/interface/api/29539) 的 **请求函数**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/projectcollection/{projectCollectionId}`
 * @更新时间 `2025-08-18 14:15:05`
 */
const apiGetDomeosProjectcollectionProjectCollectionId = /*#__PURE__*/ (
  requestData: ApiGetDomeosProjectcollectionProjectCollectionIdRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetDomeosProjectcollectionProjectCollectionIdResponse>(
    prepare(
      apiGetDomeosProjectcollectionProjectCollectionIdRequestConfig,
      requestData
    ),
    ...args
  )
}

apiGetDomeosProjectcollectionProjectCollectionId.requestConfig =
  apiGetDomeosProjectcollectionProjectCollectionIdRequestConfig

/**
 * 接口 [部署-项目详情↗](http://10.19.12.152:8989/project/502/interface/api/29539) 的 **React Hook**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/projectcollection/{projectCollectionId}`
 * @更新时间 `2025-08-18 14:15:05`
 */
export const useApiGetDomeosProjectcollectionProjectCollectionId =
  /*#__PURE__*/ makeRequestHook<
    ApiGetDomeosProjectcollectionProjectCollectionIdRequest,
    ApiGetDomeosProjectcollectionProjectCollectionIdRequestConfig,
    ReturnType<typeof apiGetDomeosProjectcollectionProjectCollectionId>
  >(apiGetDomeosProjectcollectionProjectCollectionId)

/**
 * 接口 [部署-工程列表↗](http://10.19.12.152:8989/project/502/interface/api/29546) 的 **请求类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/project/collection/{projectCollectionId}`
 * @更新时间 `2025-08-18 14:15:07`
 */
export interface ApiGetDomeosProjectCollectionProjectCollectionIdRequest {
  /**
   * 项目id
   */
  projectCollectionId: string
}

/**
 * 接口 [部署-工程列表↗](http://10.19.12.152:8989/project/502/interface/api/29546) 的 **返回类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/project/collection/{projectCollectionId}`
 * @更新时间 `2025-08-18 14:15:07`
 */
export type ApiGetDomeosProjectCollectionProjectCollectionIdResponse = {
  /**
   * 工程id
   */
  id: number
  /**
   * 工程名称
   */
  name: string
  description: string
  state: string
  /**
   * 工程创建时间
   */
  createTime: number
  removeTime: number
  removed: boolean
  /**
   * 构建类型：TWOPHASE;PIPELINE;CUSTOM
   */
  buildType: string
  codeInfo: {
    codeManager?: string
    codeProjects?: {
      id: number
      name: string
      sshUrl: string
      httpUrl: string
      description: null | string
      createTime: number
      runnersToken: null
      autoBuild: {
        tag?: number
        branches?: string[] | null
        branchRegex?: boolean
      }
      storagePath: string
    }[]
    [k: string]: unknown
  } | null
  codeManagerUserId: number
  common: {
    imageInfo?: {
      registry?: string
      name?: string
      tag?: string
      type?: string
    }
    compileEnvs?: null
    runEnvs?: null
    compileCmd?: null
    runWorkDir?: null
    runStartCmd?: string
    runUser?: null
    confFiles?: null
    [k: string]: unknown
  } | null
  creatorInfo: {
    id: number
    name: string
  }
  /**
   * 构建信息
   */
  buildInfo: {
    /**
     * 构建时间
     */
    createTime: number
    /**
     * 构建时间
     */
    status: string
  }
  collectionInfo: string
  role: string
}[]

/**
 * 接口 [部署-工程列表↗](http://10.19.12.152:8989/project/502/interface/api/29546) 的 **请求配置的类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/project/collection/{projectCollectionId}`
 * @更新时间 `2025-08-18 14:15:07`
 */
type ApiGetDomeosProjectCollectionProjectCollectionIdRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/domeos/project/collection/{projectCollectionId}',
    'data',
    'projectCollectionId',
    string,
    false
  >
>

/**
 * 接口 [部署-工程列表↗](http://10.19.12.152:8989/project/502/interface/api/29546) 的 **请求配置**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/project/collection/{projectCollectionId}`
 * @更新时间 `2025-08-18 14:15:07`
 */
const apiGetDomeosProjectCollectionProjectCollectionIdRequestConfig: ApiGetDomeosProjectCollectionProjectCollectionIdRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/api/app/domeos/project/collection/{projectCollectionId}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: ['projectCollectionId'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetDomeosProjectCollectionProjectCollectionId',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [部署-工程列表↗](http://10.19.12.152:8989/project/502/interface/api/29546) 的 **请求函数**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/project/collection/{projectCollectionId}`
 * @更新时间 `2025-08-18 14:15:07`
 */
const apiGetDomeosProjectCollectionProjectCollectionId = /*#__PURE__*/ (
  requestData: ApiGetDomeosProjectCollectionProjectCollectionIdRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetDomeosProjectCollectionProjectCollectionIdResponse>(
    prepare(
      apiGetDomeosProjectCollectionProjectCollectionIdRequestConfig,
      requestData
    ),
    ...args
  )
}

apiGetDomeosProjectCollectionProjectCollectionId.requestConfig =
  apiGetDomeosProjectCollectionProjectCollectionIdRequestConfig

/**
 * 接口 [部署-工程列表↗](http://10.19.12.152:8989/project/502/interface/api/29546) 的 **React Hook**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/project/collection/{projectCollectionId}`
 * @更新时间 `2025-08-18 14:15:07`
 */
export const useApiGetDomeosProjectCollectionProjectCollectionId =
  /*#__PURE__*/ makeRequestHook<
    ApiGetDomeosProjectCollectionProjectCollectionIdRequest,
    ApiGetDomeosProjectCollectionProjectCollectionIdRequestConfig,
    ReturnType<typeof apiGetDomeosProjectCollectionProjectCollectionId>
  >(apiGetDomeosProjectCollectionProjectCollectionId)

/**
 * 接口 [部署-创建版本可选主机标签↗](http://10.19.12.152:8989/project/502/interface/api/29595) 的 **请求类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/cluster/{clusterId}/nodeUserLabelList`
 * @更新时间 `2025-08-18 14:15:09`
 */
export interface ApiGetDomeosClusterClusterIdNodeUserLabelListRequest {
  /**
   * 资源包id
   */
  bundleId: string
  clusterId: string
}

/**
 * 接口 [部署-创建版本可选主机标签↗](http://10.19.12.152:8989/project/502/interface/api/29595) 的 **返回类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/cluster/{clusterId}/nodeUserLabelList`
 * @更新时间 `2025-08-18 14:15:09`
 */
export type ApiGetDomeosClusterClusterIdNodeUserLabelListResponse = string[]

/**
 * 接口 [部署-创建版本可选主机标签↗](http://10.19.12.152:8989/project/502/interface/api/29595) 的 **请求配置的类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/cluster/{clusterId}/nodeUserLabelList`
 * @更新时间 `2025-08-18 14:15:09`
 */
type ApiGetDomeosClusterClusterIdNodeUserLabelListRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/domeos/cluster/{clusterId}/nodeUserLabelList',
    'data',
    'clusterId',
    'bundleId',
    false
  >
>

/**
 * 接口 [部署-创建版本可选主机标签↗](http://10.19.12.152:8989/project/502/interface/api/29595) 的 **请求配置**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/cluster/{clusterId}/nodeUserLabelList`
 * @更新时间 `2025-08-18 14:15:09`
 */
const apiGetDomeosClusterClusterIdNodeUserLabelListRequestConfig: ApiGetDomeosClusterClusterIdNodeUserLabelListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/api/app/domeos/cluster/{clusterId}/nodeUserLabelList',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: ['clusterId'],
    queryNames: ['bundleId'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetDomeosClusterClusterIdNodeUserLabelList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [部署-创建版本可选主机标签↗](http://10.19.12.152:8989/project/502/interface/api/29595) 的 **请求函数**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/cluster/{clusterId}/nodeUserLabelList`
 * @更新时间 `2025-08-18 14:15:09`
 */
const apiGetDomeosClusterClusterIdNodeUserLabelList = /*#__PURE__*/ (
  requestData: ApiGetDomeosClusterClusterIdNodeUserLabelListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetDomeosClusterClusterIdNodeUserLabelListResponse>(
    prepare(
      apiGetDomeosClusterClusterIdNodeUserLabelListRequestConfig,
      requestData
    ),
    ...args
  )
}

apiGetDomeosClusterClusterIdNodeUserLabelList.requestConfig =
  apiGetDomeosClusterClusterIdNodeUserLabelListRequestConfig

/**
 * 接口 [部署-创建版本可选主机标签↗](http://10.19.12.152:8989/project/502/interface/api/29595) 的 **React Hook**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/cluster/{clusterId}/nodeUserLabelList`
 * @更新时间 `2025-08-18 14:15:09`
 */
export const useApiGetDomeosClusterClusterIdNodeUserLabelList =
  /*#__PURE__*/ makeRequestHook<
    ApiGetDomeosClusterClusterIdNodeUserLabelListRequest,
    ApiGetDomeosClusterClusterIdNodeUserLabelListRequestConfig,
    ReturnType<typeof apiGetDomeosClusterClusterIdNodeUserLabelList>
  >(apiGetDomeosClusterClusterIdNodeUserLabelList)

/**
 * 接口 [部署=实例重启↗](http://10.19.12.152:8989/project/502/interface/api/29609) 的 **请求类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `POST /api/app/domeos/deploy/{deployId}/instance`
 * @更新时间 `2025-09-16 16:38:21`
 */
export interface ApiPostDomeosDeployDeployIdInstanceRequest {
  /**
   * 强制立即重启
   */
  force: string
  /**
   * 实例名
   */
  insName: string
  deployId: string
}

/**
 * 接口 [部署=实例重启↗](http://10.19.12.152:8989/project/502/interface/api/29609) 的 **返回类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `POST /api/app/domeos/deploy/{deployId}/instance`
 * @更新时间 `2025-09-16 16:38:21`
 */
export interface ApiPostDomeosDeployDeployIdInstanceResponse {}

/**
 * 接口 [部署=实例重启↗](http://10.19.12.152:8989/project/502/interface/api/29609) 的 **请求配置的类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `POST /api/app/domeos/deploy/{deployId}/instance`
 * @更新时间 `2025-09-16 16:38:21`
 */
type ApiPostDomeosDeployDeployIdInstanceRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/domeos/deploy/{deployId}/instance',
    'data',
    'deployId',
    'force' | 'insName',
    false
  >
>

/**
 * 接口 [部署=实例重启↗](http://10.19.12.152:8989/project/502/interface/api/29609) 的 **请求配置**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `POST /api/app/domeos/deploy/{deployId}/instance`
 * @更新时间 `2025-09-16 16:38:21`
 */
const apiPostDomeosDeployDeployIdInstanceRequestConfig: ApiPostDomeosDeployDeployIdInstanceRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/api/app/domeos/deploy/{deployId}/instance',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: ['deployId'],
    queryNames: ['force', 'insName'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPostDomeosDeployDeployIdInstance',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [部署=实例重启↗](http://10.19.12.152:8989/project/502/interface/api/29609) 的 **请求函数**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `POST /api/app/domeos/deploy/{deployId}/instance`
 * @更新时间 `2025-09-16 16:38:21`
 */
const apiPostDomeosDeployDeployIdInstance = /*#__PURE__*/ (
  requestData: ApiPostDomeosDeployDeployIdInstanceRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPostDomeosDeployDeployIdInstanceResponse>(
    prepare(apiPostDomeosDeployDeployIdInstanceRequestConfig, requestData),
    ...args
  )
}

apiPostDomeosDeployDeployIdInstance.requestConfig =
  apiPostDomeosDeployDeployIdInstanceRequestConfig

/**
 * 接口 [部署=实例重启↗](http://10.19.12.152:8989/project/502/interface/api/29609) 的 **React Hook**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `POST /api/app/domeos/deploy/{deployId}/instance`
 * @更新时间 `2025-09-16 16:38:21`
 */
export const useApiPostDomeosDeployDeployIdInstance =
  /*#__PURE__*/ makeRequestHook<
    ApiPostDomeosDeployDeployIdInstanceRequest,
    ApiPostDomeosDeployDeployIdInstanceRequestConfig,
    ReturnType<typeof apiPostDomeosDeployDeployIdInstance>
  >(apiPostDomeosDeployDeployIdInstance)

/**
 * 接口 [部署-构建记录↗](http://10.19.12.152:8989/project/502/interface/api/29812) 的 **请求类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/ci/build/page/{collectionId}`
 * @更新时间 `2025-09-05 17:13:26`
 */
export interface ApiGetDomeosCiBuildPageCollectionIdRequest {
  /**
   * 开始index
   */
  start: string
  count: string
  /**
   * 最新构建记录id
   */
  firstId: string
  /**
   * 工程id
   */
  collectionId: string
}

/**
 * 接口 [部署-构建记录↗](http://10.19.12.152:8989/project/502/interface/api/29812) 的 **返回类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/ci/build/page/{collectionId}`
 * @更新时间 `2025-09-05 17:13:26`
 */
export interface ApiGetDomeosCiBuildPageCollectionIdResponse {
  total: number
  /**
   * 构建记录
   */
  values: {
    id: number
    name: string
    description: string
    /**
     * 状态，Success; Fail;Stopped
     */
    state: string
    /**
     * 13位时间戳
     */
    createTime: number
    removeTime: number
    removed: boolean
    projectId: number
    buildCodeInfos: {
      codeInfo: {
        codeBranch: string
        codeTag: null
        codeId: number
        codeName: string
        storagePath: string
        runnersToken: null
        sshUrl: string
        httpUrl: string
        codeManager: string
        codeManagerUserId: number
      }
      commitInfo: {
        id: string
        message: string
        authorName: string
        authorEmail: string
        createdAt: number
      }
    }[]
    /**
     * 镜像信息
     */
    imageInfo: {
      registry: string
      /**
       * 工程名称
       */
      name: string
      /**
       * tag
       */
      tag: string
      type: null
      imageSize: number
      createTime: number
    }
    finishTime: number
    currentTime: number
    message: string
    userInfo: {
      id: number
      name: string
    }
    autoBuild: number
    log?: null
    dockerfileContent?: null
    common?: null
    custom?: null
    codeIn?: null
    twoPhase?: null
    /**
     * TWOPHASE
     */
    buildType: string
    secret: string
    ciClusterId: number
    namespace: string
    /**
     * 加速构建
     */
    speedUpBuild: {
      buildTool: string
      cachePath: string
    }
    subCodeProjects: null
    buildNodeName: null
  }[]
  firstId: number
  registryUrl: string
  authRegistryEnabled: boolean
}

/**
 * 接口 [部署-构建记录↗](http://10.19.12.152:8989/project/502/interface/api/29812) 的 **请求配置的类型**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/ci/build/page/{collectionId}`
 * @更新时间 `2025-09-05 17:13:26`
 */
type ApiGetDomeosCiBuildPageCollectionIdRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/domeos/ci/build/page/{collectionId}',
    'data',
    'collectionId',
    'start' | 'count' | 'firstId',
    false
  >
>

/**
 * 接口 [部署-构建记录↗](http://10.19.12.152:8989/project/502/interface/api/29812) 的 **请求配置**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/ci/build/page/{collectionId}`
 * @更新时间 `2025-09-05 17:13:26`
 */
const apiGetDomeosCiBuildPageCollectionIdRequestConfig: ApiGetDomeosCiBuildPageCollectionIdRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/api/app/domeos/ci/build/page/{collectionId}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: ['collectionId'],
    queryNames: ['start', 'count', 'firstId'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetDomeosCiBuildPageCollectionId',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [部署-构建记录↗](http://10.19.12.152:8989/project/502/interface/api/29812) 的 **请求函数**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/ci/build/page/{collectionId}`
 * @更新时间 `2025-09-05 17:13:26`
 */
const apiGetDomeosCiBuildPageCollectionId = /*#__PURE__*/ (
  requestData: ApiGetDomeosCiBuildPageCollectionIdRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetDomeosCiBuildPageCollectionIdResponse>(
    prepare(apiGetDomeosCiBuildPageCollectionIdRequestConfig, requestData),
    ...args
  )
}

apiGetDomeosCiBuildPageCollectionId.requestConfig =
  apiGetDomeosCiBuildPageCollectionIdRequestConfig

/**
 * 接口 [部署-构建记录↗](http://10.19.12.152:8989/project/502/interface/api/29812) 的 **React Hook**
 *
 * @分类 [DomeOS↗](http://10.19.12.152:8989/project/502/interface/api/cat_4232)
 * @标签 `二次编辑`
 * @请求头 `GET /api/app/domeos/ci/build/page/{collectionId}`
 * @更新时间 `2025-09-05 17:13:26`
 */
export const useApiGetDomeosCiBuildPageCollectionId =
  /*#__PURE__*/ makeRequestHook<
    ApiGetDomeosCiBuildPageCollectionIdRequest,
    ApiGetDomeosCiBuildPageCollectionIdRequestConfig,
    ReturnType<typeof apiGetDomeosCiBuildPageCollectionId>
  >(apiGetDomeosCiBuildPageCollectionId)

const mockUrl_0_0_0_3 = 'http://10.19.12.152:8989/mock/502' as any
const devUrl_0_0_0_3 = '' as any
const prodUrl_0_0_0_3 = '' as any
const dataKey_0_0_0_3 = 'data' as any

/**
 * 接口 [实例列表-POST↗](http://10.19.12.152:8989/project/502/interface/api/33235) 的 **请求类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/inst/list`
 * @更新时间 `2026-01-20 17:27:36`
 */
export interface ApiPostHxeInstListRequest {
  envType?: number
  type?: number
  statId?: number
  /**
   * 用于搜索
   */
  search?: string
  searchKey?: string
  sdate?: number
  edate?: number
  index?: number
  len?: number
  orderKey?: string
  /**
   * 0-asc 1-desc
   */
  order?: number
  version?: number
  aliveType?: number
  /**
   * 分页参数
   */
  page?: number
  /**
   * 分页大小
   */
  pageSize?: number
}

/**
 * 接口 [实例列表-POST↗](http://10.19.12.152:8989/project/502/interface/api/33235) 的 **返回类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/inst/list`
 * @更新时间 `2026-01-20 17:27:36`
 */
export interface ApiPostHxeInstListResponse {
  objList?: {
    uid?: number
    password?: string
    statId?: number
    totalMem?: number
    usedMem?: number
    usedMemRate?: number
    dc?: string
    dc1?: string
    createDatetime?: number
    creatorId?: string
    isPersistence?: number
    freePeriod?: number
    currentExpireDate?: number
    info?: string
    envType?: number
    type?: number
    isEdit?: number
    realName?: string
    department?: string
    visitor?: number
    /**
     * 是否在回收站
     */
    isRecycled?: number
    quotaId?: number
    version?: number
    uids?: string
    aliveType?: number
    aliveGroupId?: number
    subInsts?: {
      uid?: number
      password?: string
      statId?: number
      totalMem?: number
      usedMem?: number
      usedMemRate?: number
      dc?: string
      dc1?: string
      createDatetime?: number
      creatorId?: string
      isPersistence?: number
      freePeriod?: number
      currentExpireDate?: number
      info?: string
      envType?: number
      type?: number
      isEdit?: number
      realName?: string
      department?: string
      visitor?: number
      /**
       * 是否在回收站
       */
      isRecycled?: number
      quotaId?: number
      version?: number
      uids?: string
      aliveType?: number
      aliveGroupId?: number
      subInsts?: {}[]
      syncState?: number
    }[]
    syncState?: number
  }[]
  totalCount?: number
}

/**
 * 接口 [实例列表-POST↗](http://10.19.12.152:8989/project/502/interface/api/33235) 的 **请求配置的类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/inst/list`
 * @更新时间 `2026-01-20 17:27:36`
 */
type ApiPostHxeInstListRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/hxe/inst/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [实例列表-POST↗](http://10.19.12.152:8989/project/502/interface/api/33235) 的 **请求配置**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/inst/list`
 * @更新时间 `2026-01-20 17:27:36`
 */
const apiPostHxeInstListRequestConfig: ApiPostHxeInstListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: '/api/app/hxe/inst/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPostHxeInstList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [实例列表-POST↗](http://10.19.12.152:8989/project/502/interface/api/33235) 的 **请求函数**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/inst/list`
 * @更新时间 `2026-01-20 17:27:36`
 */
const apiPostHxeInstList = /*#__PURE__*/ (
  requestData: ApiPostHxeInstListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPostHxeInstListResponse>(
    prepare(apiPostHxeInstListRequestConfig, requestData),
    ...args
  )
}

apiPostHxeInstList.requestConfig = apiPostHxeInstListRequestConfig

/**
 * 接口 [实例列表-POST↗](http://10.19.12.152:8989/project/502/interface/api/33235) 的 **React Hook**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/inst/list`
 * @更新时间 `2026-01-20 17:27:36`
 */
export const useApiPostHxeInstList = /*#__PURE__*/ makeRequestHook<
  ApiPostHxeInstListRequest,
  ApiPostHxeInstListRequestConfig,
  ReturnType<typeof apiPostHxeInstList>
>(apiPostHxeInstList)

/**
 * 接口 [实例详情-POST↗](http://10.19.12.152:8989/project/502/interface/api/33242) 的 **请求类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/inst/info`
 * @更新时间 `2026-01-20 17:27:36`
 */
export interface ApiPostHxeInstInfoRequest {
  uid?: number
  type?: number
  envType?: number
}

/**
 * 接口 [实例详情-POST↗](http://10.19.12.152:8989/project/502/interface/api/33242) 的 **返回类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/inst/info`
 * @更新时间 `2026-01-20 17:27:36`
 */
export interface ApiPostHxeInstInfoResponse {
  instInfo?: {
    uid?: number
    type?: number
    dc?: string
    dc1?: string
    quota?: number
    quotaId?: number
    maxmemPolicy?: number
    slaveNum?: number
    isPersistence?: number
    persistenceFreq?: string
    info?: string
    envType?: number
    isDisasterRecovery?: number
    password?: string
    totalMem?: number
    usedMem?: number
    usedMemRate?: number
    freePeriod?: number
    createDatetime?: number
    creatorId?: string
    isEdit?: number
    applyId?: number
    activeFields?: string[]
    extInfo?: string
    period?: number
    version?: number
    realName?: string
    department?: string
    currentExpireDate?: number
    imageVal?: string
    imageId?: number
    groupIds?: string
    groupVal?: string
    imageName?: string
    /**
     * 集群实例持久化策略
     */
    savePeriod?: number[]
    saveTime?: string
    aliveType?: number
    /**
     * 配置变更进度
     */
    configProgress?: string
  }
  apiUrl?: {
    apiv1?: string
    apiv2?: string
    apiInfos?: {
      role?: string
      ip?: string
      port?: number
      persistence?: number
    }[]
  }
}

/**
 * 接口 [实例详情-POST↗](http://10.19.12.152:8989/project/502/interface/api/33242) 的 **请求配置的类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/inst/info`
 * @更新时间 `2026-01-20 17:27:36`
 */
type ApiPostHxeInstInfoRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/hxe/inst/info',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [实例详情-POST↗](http://10.19.12.152:8989/project/502/interface/api/33242) 的 **请求配置**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/inst/info`
 * @更新时间 `2026-01-20 17:27:36`
 */
const apiPostHxeInstInfoRequestConfig: ApiPostHxeInstInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: '/api/app/hxe/inst/info',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPostHxeInstInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [实例详情-POST↗](http://10.19.12.152:8989/project/502/interface/api/33242) 的 **请求函数**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/inst/info`
 * @更新时间 `2026-01-20 17:27:36`
 */
const apiPostHxeInstInfo = /*#__PURE__*/ (
  requestData: ApiPostHxeInstInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPostHxeInstInfoResponse>(
    prepare(apiPostHxeInstInfoRequestConfig, requestData),
    ...args
  )
}

apiPostHxeInstInfo.requestConfig = apiPostHxeInstInfoRequestConfig

/**
 * 接口 [实例详情-POST↗](http://10.19.12.152:8989/project/502/interface/api/33242) 的 **React Hook**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/inst/info`
 * @更新时间 `2026-01-20 17:27:36`
 */
export const useApiPostHxeInstInfo = /*#__PURE__*/ makeRequestHook<
  ApiPostHxeInstInfoRequest,
  ApiPostHxeInstInfoRequestConfig,
  ReturnType<typeof apiPostHxeInstInfo>
>(apiPostHxeInstInfo)

/**
 * 接口 [告警列表-POST↗](http://10.19.12.152:8989/project/502/interface/api/33249) 的 **请求类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/alert/history/list`
 * @更新时间 `2026-01-20 17:27:37`
 */
export interface ApiPostHxeAlertHistoryListRequest {
  /**
   * 搜索的id
   */
  id?: number
  /**
   * 搜索项
   */
  search?: string
  /**
   * 开始时间
   */
  sdt?: number
  /**
   * 结束时间
   */
  edt?: number
  /**
   * 用于分页的index
   */
  index?: number
  /**
   * 用于分页的len
   */
  num?: number
  /**
   * 排序
   */
  orderKey?: string
  /**
   * order 0 -asc 1-desc
   */
  order?: number
  /**
   * 告警状态  1-告警 2-结束
   */
  status?: number
  /**
   * ruleId
   */
  ruleId?: number
  uid?: number
  level?: number
}

/**
 * 接口 [告警列表-POST↗](http://10.19.12.152:8989/project/502/interface/api/33249) 的 **返回类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/alert/history/list`
 * @更新时间 `2026-01-20 17:27:37`
 */
export interface ApiPostHxeAlertHistoryListResponse {
  objList?: {
    /**
     * 告警历史的id
     */
    id?: number
    /**
     * 告警rule的id
     */
    ruleId?: number
    /**
     * 规则名称
     */
    name?: string
    /**
     * 规则应用的uid
     */
    uid?: number
    /**
     * 实例的描述信息
     */
    info?: string
    /**
     * 规则开始时间
     */
    startTime?: number
    /**
     * 规则结束时间
     */
    endTime?: number
    /**
     * 持续时间
     */
    duration?: string
    /**
     * 状态 1.正在报警中 2.报警结束
     */
    status?: number
    /**
     * 发送告警次数
     */
    count?: number
    /**
     * labels
     */
    labels?: string
    /**
     * role 1.master 2.slave
     */
    role?: string
    /**
     * userid
     */
    userId?: string
    /**
     * instance
     */
    instance?: string
    /**
     * createTime
     */
    createTime?: number
    /**
     * 1.主从 2.集群
     */
    instType?: number
    /**
     * alertType 1.阈值告警 2.事件告警
     */
    ruleType?: number
    /**
     * 节点的node信息
     */
    node?: string
    /**
     * 当前值
     */
    currentValue?: number
    alertRule?: {
      id?: number
      type?: number
      envType?: number
      /**
       * 1- 所有资源 2-uids
       */
      scope?: number
      uids?: number[]
      status?: number
      delStatus?: number
      enable?: number
      name?: string
      userId?: string
      ruleType?: number
      description?: string
      rule?: {
        item?: string
        itemName?: string
        check?: string
        operator?: string
        value1?: number
        value2?: number
        eventId?: number
        EnvntName?: string
      }
      rules?: {
        ruleType?: number
        name?: string
        description?: string
        rule?: {
          item?: string
          itemName?: string
          check?: string
          operator?: string
          value1?: number
          value2?: number
          eventId?: number
          EnvntName?: string
        }
      }[]
      interval?: string
      activeTime?: string[]
      alertType?: number[]
      email?: string[]
      phone?: string[]
      wechat?: string[]
      createTime?: number
      updateTime?: number
      lastModifyUser?: string
      alertGroupUpgraded?: boolean
      alertGroup?: number[]
      alertGroupEntities?: {
        id?: number
        name?: string
        description?: string
        ownerId?: number
        createTime?: number
        /**
         * true则表示有校，数据库对应是1，数据库默认也为1，现在可能有问题。如果该条数据被删除，则为false，数据库为0
         */
        status?: boolean
      }[]
      realName?: string
    }
    updateTime?: number
  }[]
  totalCount?: number
}

/**
 * 接口 [告警列表-POST↗](http://10.19.12.152:8989/project/502/interface/api/33249) 的 **请求配置的类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/alert/history/list`
 * @更新时间 `2026-01-20 17:27:37`
 */
type ApiPostHxeAlertHistoryListRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/hxe/alert/history/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [告警列表-POST↗](http://10.19.12.152:8989/project/502/interface/api/33249) 的 **请求配置**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/alert/history/list`
 * @更新时间 `2026-01-20 17:27:37`
 */
const apiPostHxeAlertHistoryListRequestConfig: ApiPostHxeAlertHistoryListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: '/api/app/hxe/alert/history/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPostHxeAlertHistoryList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [告警列表-POST↗](http://10.19.12.152:8989/project/502/interface/api/33249) 的 **请求函数**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/alert/history/list`
 * @更新时间 `2026-01-20 17:27:37`
 */
const apiPostHxeAlertHistoryList = /*#__PURE__*/ (
  requestData: ApiPostHxeAlertHistoryListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPostHxeAlertHistoryListResponse>(
    prepare(apiPostHxeAlertHistoryListRequestConfig, requestData),
    ...args
  )
}

apiPostHxeAlertHistoryList.requestConfig =
  apiPostHxeAlertHistoryListRequestConfig

/**
 * 接口 [告警列表-POST↗](http://10.19.12.152:8989/project/502/interface/api/33249) 的 **React Hook**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/alert/history/list`
 * @更新时间 `2026-01-20 17:27:37`
 */
export const useApiPostHxeAlertHistoryList = /*#__PURE__*/ makeRequestHook<
  ApiPostHxeAlertHistoryListRequest,
  ApiPostHxeAlertHistoryListRequestConfig,
  ReturnType<typeof apiPostHxeAlertHistoryList>
>(apiPostHxeAlertHistoryList)

/**
 * 接口 [监控数据-POST↗](http://10.19.12.152:8989/project/502/interface/api/33256) 的 **请求类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/monitor/datas`
 * @更新时间 `2026-01-20 17:27:37`
 */
export interface ApiPostHxeMonitorDatasRequest {
  uid?: number
  node?: string
  items?: string
  analysis?: boolean
  sdt?: number
  edt?: number
  scale?: number
}

/**
 * 接口 [监控数据-POST↗](http://10.19.12.152:8989/project/502/interface/api/33256) 的 **返回类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/monitor/datas`
 * @更新时间 `2026-01-20 17:27:37`
 */
export type ApiPostHxeMonitorDatasResponse = {
  node?: string
  info?: string
  itemDataList?: {
    item?: string
    unit?: string
    values?: {
      key?: number
      val?: number
    }[]
  }[]
}[]

/**
 * 接口 [监控数据-POST↗](http://10.19.12.152:8989/project/502/interface/api/33256) 的 **请求配置的类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/monitor/datas`
 * @更新时间 `2026-01-20 17:27:37`
 */
type ApiPostHxeMonitorDatasRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/hxe/monitor/datas',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [监控数据-POST↗](http://10.19.12.152:8989/project/502/interface/api/33256) 的 **请求配置**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/monitor/datas`
 * @更新时间 `2026-01-20 17:27:37`
 */
const apiPostHxeMonitorDatasRequestConfig: ApiPostHxeMonitorDatasRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: '/api/app/hxe/monitor/datas',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPostHxeMonitorDatas',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [监控数据-POST↗](http://10.19.12.152:8989/project/502/interface/api/33256) 的 **请求函数**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/monitor/datas`
 * @更新时间 `2026-01-20 17:27:37`
 */
const apiPostHxeMonitorDatas = /*#__PURE__*/ (
  requestData: ApiPostHxeMonitorDatasRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPostHxeMonitorDatasResponse>(
    prepare(apiPostHxeMonitorDatasRequestConfig, requestData),
    ...args
  )
}

apiPostHxeMonitorDatas.requestConfig = apiPostHxeMonitorDatasRequestConfig

/**
 * 接口 [监控数据-POST↗](http://10.19.12.152:8989/project/502/interface/api/33256) 的 **React Hook**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/monitor/datas`
 * @更新时间 `2026-01-20 17:27:37`
 */
export const useApiPostHxeMonitorDatas = /*#__PURE__*/ makeRequestHook<
  ApiPostHxeMonitorDatasRequest,
  ApiPostHxeMonitorDatasRequestConfig,
  ReturnType<typeof apiPostHxeMonitorDatas>
>(apiPostHxeMonitorDatas)

/**
 * 接口 [操作记录-POST↗](http://10.19.12.152:8989/project/502/interface/api/33263) 的 **请求类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/auditlog/list`
 * @更新时间 `2026-01-20 17:27:37`
 */
export interface ApiPostHxeAuditlogListRequest {
  sdate?: number
  edate?: number
  userId?: string
  uid?: number
  clientIp?: string
  orderKey?: string
  /**
   * 0-asc 1-desc
   */
  order?: number
  index?: number
  len?: number
  logType?: number
}

/**
 * 接口 [操作记录-POST↗](http://10.19.12.152:8989/project/502/interface/api/33263) 的 **返回类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/auditlog/list`
 * @更新时间 `2026-01-20 17:27:37`
 */
export interface ApiPostHxeAuditlogListResponse {
  objList?: {
    id?: number
    logType?: number
    userId?: string
    uid?: number
    envType?: number
    clientIp?: string
    info?: string
    actionDate?: number
    logTypeName?: string
    uids?: string
    realName?: string
  }[]
  totalCount?: number
}

/**
 * 接口 [操作记录-POST↗](http://10.19.12.152:8989/project/502/interface/api/33263) 的 **请求配置的类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/auditlog/list`
 * @更新时间 `2026-01-20 17:27:37`
 */
type ApiPostHxeAuditlogListRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/hxe/auditlog/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [操作记录-POST↗](http://10.19.12.152:8989/project/502/interface/api/33263) 的 **请求配置**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/auditlog/list`
 * @更新时间 `2026-01-20 17:27:37`
 */
const apiPostHxeAuditlogListRequestConfig: ApiPostHxeAuditlogListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: '/api/app/hxe/auditlog/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPostHxeAuditlogList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [操作记录-POST↗](http://10.19.12.152:8989/project/502/interface/api/33263) 的 **请求函数**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/auditlog/list`
 * @更新时间 `2026-01-20 17:27:37`
 */
const apiPostHxeAuditlogList = /*#__PURE__*/ (
  requestData: ApiPostHxeAuditlogListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPostHxeAuditlogListResponse>(
    prepare(apiPostHxeAuditlogListRequestConfig, requestData),
    ...args
  )
}

apiPostHxeAuditlogList.requestConfig = apiPostHxeAuditlogListRequestConfig

/**
 * 接口 [操作记录-POST↗](http://10.19.12.152:8989/project/502/interface/api/33263) 的 **React Hook**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/auditlog/list`
 * @更新时间 `2026-01-20 17:27:37`
 */
export const useApiPostHxeAuditlogList = /*#__PURE__*/ makeRequestHook<
  ApiPostHxeAuditlogListRequest,
  ApiPostHxeAuditlogListRequestConfig,
  ReturnType<typeof apiPostHxeAuditlogList>
>(apiPostHxeAuditlogList)

/**
 * 接口 [实例数量↗](http://10.19.12.152:8989/project/502/interface/api/33270) 的 **请求类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/inst/count`
 * @更新时间 `2026-01-20 17:27:35`
 */
export interface ApiGetHxeInstCountRequest {}

/**
 * 接口 [实例数量↗](http://10.19.12.152:8989/project/502/interface/api/33270) 的 **返回类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/inst/count`
 * @更新时间 `2026-01-20 17:27:35`
 */
export interface ApiGetHxeInstCountResponse {
  /**
   * 主从生产
   */
  msPro?: number
  /**
   * 主从测试
   */
  msTest?: number
  /**
   * 集群生产
   */
  clsPro?: number
  /**
   * 集群测试
   */
  clsTest?: number
  /**
   * pika
   */
  pika?: number
  /**
   * 双活生产
   */
  mmPro?: number
  /**
   * 双活测试
   */
  mmTest?: number
  /**
   * 总数
   */
  all?: number
}

/**
 * 接口 [实例数量↗](http://10.19.12.152:8989/project/502/interface/api/33270) 的 **请求配置的类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/inst/count`
 * @更新时间 `2026-01-20 17:27:35`
 */
type ApiGetHxeInstCountRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/hxe/inst/count',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [实例数量↗](http://10.19.12.152:8989/project/502/interface/api/33270) 的 **请求配置**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/inst/count`
 * @更新时间 `2026-01-20 17:27:35`
 */
const apiGetHxeInstCountRequestConfig: ApiGetHxeInstCountRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: '/api/app/hxe/inst/count',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetHxeInstCount',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [实例数量↗](http://10.19.12.152:8989/project/502/interface/api/33270) 的 **请求函数**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/inst/count`
 * @更新时间 `2026-01-20 17:27:35`
 */
const apiGetHxeInstCount = /*#__PURE__*/ (
  requestData?: ApiGetHxeInstCountRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetHxeInstCountResponse>(
    prepare(apiGetHxeInstCountRequestConfig, requestData),
    ...args
  )
}

apiGetHxeInstCount.requestConfig = apiGetHxeInstCountRequestConfig

/**
 * 接口 [实例数量↗](http://10.19.12.152:8989/project/502/interface/api/33270) 的 **React Hook**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/inst/count`
 * @更新时间 `2026-01-20 17:27:35`
 */
export const useApiGetHxeInstCount = /*#__PURE__*/ makeRequestHook<
  ApiGetHxeInstCountRequest,
  ApiGetHxeInstCountRequestConfig,
  ReturnType<typeof apiGetHxeInstCount>
>(apiGetHxeInstCount)

/**
 * 接口 [概览数量↗](http://10.19.12.152:8989/project/502/interface/api/34327) 的 **请求类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/overview`
 * @更新时间 `2026-01-20 17:27:35`
 */
export interface ApiGetHxeOverviewRequest {}

/**
 * 接口 [概览数量↗](http://10.19.12.152:8989/project/502/interface/api/34327) 的 **返回类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/overview`
 * @更新时间 `2026-01-20 17:27:35`
 */
export interface ApiGetHxeOverviewResponse {
  instCount?: number
  alertCount?: number
}

/**
 * 接口 [概览数量↗](http://10.19.12.152:8989/project/502/interface/api/34327) 的 **请求配置的类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/overview`
 * @更新时间 `2026-01-20 17:27:35`
 */
type ApiGetHxeOverviewRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/hxe/overview',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [概览数量↗](http://10.19.12.152:8989/project/502/interface/api/34327) 的 **请求配置**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/overview`
 * @更新时间 `2026-01-20 17:27:35`
 */
const apiGetHxeOverviewRequestConfig: ApiGetHxeOverviewRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: '/api/app/hxe/overview',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetHxeOverview',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [概览数量↗](http://10.19.12.152:8989/project/502/interface/api/34327) 的 **请求函数**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/overview`
 * @更新时间 `2026-01-20 17:27:35`
 */
const apiGetHxeOverview = /*#__PURE__*/ (
  requestData?: ApiGetHxeOverviewRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetHxeOverviewResponse>(
    prepare(apiGetHxeOverviewRequestConfig, requestData),
    ...args
  )
}

apiGetHxeOverview.requestConfig = apiGetHxeOverviewRequestConfig

/**
 * 接口 [概览数量↗](http://10.19.12.152:8989/project/502/interface/api/34327) 的 **React Hook**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/overview`
 * @更新时间 `2026-01-20 17:27:35`
 */
export const useApiGetHxeOverview = /*#__PURE__*/ makeRequestHook<
  ApiGetHxeOverviewRequest,
  ApiGetHxeOverviewRequestConfig,
  ReturnType<typeof apiGetHxeOverview>
>(apiGetHxeOverview)

/**
 * 接口 [告警列表-GET↗](http://10.19.12.152:8989/project/502/interface/api/34334) 的 **请求类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/alert/history/list`
 * @更新时间 `2026-01-20 17:27:36`
 */
export interface ApiGetHxeAlertHistoryListRequest {
  /**
   * 搜索的id
   */
  id?: string
  /**
   * 搜索项
   */
  search?: string
  /**
   * 开始时间
   */
  sdt?: string
  /**
   * 结束时间
   */
  edt?: string
  /**
   * 用于分页的index
   */
  index?: string
  /**
   * 用于分页的len
   */
  num?: string
  /**
   * 排序
   */
  orderKey?: string
  /**
   * order 0 -asc 1-desc
   */
  order?: string
  /**
   * 告警状态  1-告警 2-结束
   */
  status?: string
  /**
   * ruleId
   */
  ruleId?: string
  uid?: string
  level?: string
}

/**
 * 接口 [告警列表-GET↗](http://10.19.12.152:8989/project/502/interface/api/34334) 的 **返回类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/alert/history/list`
 * @更新时间 `2026-01-20 17:27:36`
 */
export interface ApiGetHxeAlertHistoryListResponse {
  objList?: {
    /**
     * 告警历史的id
     */
    id?: number
    /**
     * 告警rule的id
     */
    ruleId?: number
    /**
     * 规则名称
     */
    name?: string
    /**
     * 规则应用的uid
     */
    uid?: number
    /**
     * 实例的描述信息
     */
    info?: string
    /**
     * 规则开始时间
     */
    startTime?: number
    /**
     * 规则结束时间
     */
    endTime?: number
    /**
     * 持续时间
     */
    duration?: string
    /**
     * 状态 1.正在报警中 2.报警结束
     */
    status?: number
    /**
     * 发送告警次数
     */
    count?: number
    /**
     * labels
     */
    labels?: string
    /**
     * role 1.master 2.slave
     */
    role?: string
    /**
     * userid
     */
    userId?: string
    /**
     * instance
     */
    instance?: string
    /**
     * createTime
     */
    createTime?: number
    /**
     * 1.主从 2.集群
     */
    instType?: number
    /**
     * alertType 1.阈值告警 2.事件告警
     */
    ruleType?: number
    /**
     * 节点的node信息
     */
    node?: string
    /**
     * 当前值
     */
    currentValue?: number
    alertRule?: {
      id?: number
      type?: number
      envType?: number
      /**
       * 1- 所有资源 2-uids
       */
      scope?: number
      uids?: number[]
      status?: number
      delStatus?: number
      enable?: number
      name?: string
      userId?: string
      ruleType?: number
      description?: string
      rule?: {
        item?: string
        itemName?: string
        check?: string
        operator?: string
        value1?: number
        value2?: number
        eventId?: number
        EnvntName?: string
      }
      rules?: {
        ruleType?: number
        name?: string
        description?: string
        rule?: {
          item?: string
          itemName?: string
          check?: string
          operator?: string
          value1?: number
          value2?: number
          eventId?: number
          EnvntName?: string
        }
      }[]
      interval?: string
      activeTime?: string[]
      alertType?: number[]
      email?: string[]
      phone?: string[]
      wechat?: string[]
      createTime?: number
      updateTime?: number
      lastModifyUser?: string
      alertGroupUpgraded?: boolean
      alertGroup?: number[]
      alertGroupEntities?: {
        id?: number
        name?: string
        description?: string
        ownerId?: number
        createTime?: number
        /**
         * true则表示有校，数据库对应是1，数据库默认也为1，现在可能有问题。如果该条数据被删除，则为false，数据库为0
         */
        status?: boolean
      }[]
      realName?: string
    }
    updateTime?: number
  }[]
  totalCount?: number
}

/**
 * 接口 [告警列表-GET↗](http://10.19.12.152:8989/project/502/interface/api/34334) 的 **请求配置的类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/alert/history/list`
 * @更新时间 `2026-01-20 17:27:36`
 */
type ApiGetHxeAlertHistoryListRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/hxe/alert/history/list',
    'data',
    string,
    | 'id'
    | 'search'
    | 'sdt'
    | 'edt'
    | 'index'
    | 'num'
    | 'orderKey'
    | 'order'
    | 'status'
    | 'ruleId'
    | 'uid'
    | 'level',
    false
  >
>

/**
 * 接口 [告警列表-GET↗](http://10.19.12.152:8989/project/502/interface/api/34334) 的 **请求配置**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/alert/history/list`
 * @更新时间 `2026-01-20 17:27:36`
 */
const apiGetHxeAlertHistoryListRequestConfig: ApiGetHxeAlertHistoryListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: '/api/app/hxe/alert/history/list',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: [
      'id',
      'search',
      'sdt',
      'edt',
      'index',
      'num',
      'orderKey',
      'order',
      'status',
      'ruleId',
      'uid',
      'level'
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetHxeAlertHistoryList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [告警列表-GET↗](http://10.19.12.152:8989/project/502/interface/api/34334) 的 **请求函数**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/alert/history/list`
 * @更新时间 `2026-01-20 17:27:36`
 */
const apiGetHxeAlertHistoryList = /*#__PURE__*/ (
  requestData: ApiGetHxeAlertHistoryListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetHxeAlertHistoryListResponse>(
    prepare(apiGetHxeAlertHistoryListRequestConfig, requestData),
    ...args
  )
}

apiGetHxeAlertHistoryList.requestConfig = apiGetHxeAlertHistoryListRequestConfig

/**
 * 接口 [告警列表-GET↗](http://10.19.12.152:8989/project/502/interface/api/34334) 的 **React Hook**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/alert/history/list`
 * @更新时间 `2026-01-20 17:27:36`
 */
export const useApiGetHxeAlertHistoryList = /*#__PURE__*/ makeRequestHook<
  ApiGetHxeAlertHistoryListRequest,
  ApiGetHxeAlertHistoryListRequestConfig,
  ReturnType<typeof apiGetHxeAlertHistoryList>
>(apiGetHxeAlertHistoryList)

/**
 * 接口 [监控数据-GET↗](http://10.19.12.152:8989/project/502/interface/api/34341) 的 **请求类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/monitor/datas`
 * @更新时间 `2026-01-20 17:27:37`
 */
export interface ApiGetHxeMonitorDatasRequest {
  uid?: string
  node?: string
  items?: string
  analysis?: string
  sdt?: string
  edt?: string
  scale?: string
}

/**
 * 接口 [监控数据-GET↗](http://10.19.12.152:8989/project/502/interface/api/34341) 的 **返回类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/monitor/datas`
 * @更新时间 `2026-01-20 17:27:37`
 */
export type ApiGetHxeMonitorDatasResponse = {
  node?: string
  info?: string
  itemDataList?: {
    item?: string
    unit?: string
    values?: {
      key?: number
      val?: number
    }[]
  }[]
}[]

/**
 * 接口 [监控数据-GET↗](http://10.19.12.152:8989/project/502/interface/api/34341) 的 **请求配置的类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/monitor/datas`
 * @更新时间 `2026-01-20 17:27:37`
 */
type ApiGetHxeMonitorDatasRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/hxe/monitor/datas',
    'data',
    string,
    'uid' | 'node' | 'items' | 'analysis' | 'sdt' | 'edt' | 'scale',
    false
  >
>

/**
 * 接口 [监控数据-GET↗](http://10.19.12.152:8989/project/502/interface/api/34341) 的 **请求配置**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/monitor/datas`
 * @更新时间 `2026-01-20 17:27:37`
 */
const apiGetHxeMonitorDatasRequestConfig: ApiGetHxeMonitorDatasRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: '/api/app/hxe/monitor/datas',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: ['uid', 'node', 'items', 'analysis', 'sdt', 'edt', 'scale'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetHxeMonitorDatas',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [监控数据-GET↗](http://10.19.12.152:8989/project/502/interface/api/34341) 的 **请求函数**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/monitor/datas`
 * @更新时间 `2026-01-20 17:27:37`
 */
const apiGetHxeMonitorDatas = /*#__PURE__*/ (
  requestData: ApiGetHxeMonitorDatasRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetHxeMonitorDatasResponse>(
    prepare(apiGetHxeMonitorDatasRequestConfig, requestData),
    ...args
  )
}

apiGetHxeMonitorDatas.requestConfig = apiGetHxeMonitorDatasRequestConfig

/**
 * 接口 [监控数据-GET↗](http://10.19.12.152:8989/project/502/interface/api/34341) 的 **React Hook**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/monitor/datas`
 * @更新时间 `2026-01-20 17:27:37`
 */
export const useApiGetHxeMonitorDatas = /*#__PURE__*/ makeRequestHook<
  ApiGetHxeMonitorDatasRequest,
  ApiGetHxeMonitorDatasRequestConfig,
  ReturnType<typeof apiGetHxeMonitorDatas>
>(apiGetHxeMonitorDatas)

/**
 * 接口 [操作记录-GET↗](http://10.19.12.152:8989/project/502/interface/api/34348) 的 **请求类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/auditlog/list`
 * @更新时间 `2026-01-20 17:27:37`
 */
export interface ApiGetHxeAuditlogListRequest {
  sdate?: string
  edate?: string
  userId?: string
  uid?: string
  clientIp?: string
  orderKey?: string
  /**
   * 0-asc 1-desc
   */
  order?: string
  index?: string
  len?: string
  logType?: string
}

/**
 * 接口 [操作记录-GET↗](http://10.19.12.152:8989/project/502/interface/api/34348) 的 **返回类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/auditlog/list`
 * @更新时间 `2026-01-20 17:27:37`
 */
export interface ApiGetHxeAuditlogListResponse {
  objList?: {
    id?: number
    logType?: number
    userId?: string
    uid?: number
    envType?: number
    clientIp?: string
    info?: string
    actionDate?: number
    logTypeName?: string
    uids?: string
    realName?: string
  }[]
  totalCount?: number
}

/**
 * 接口 [操作记录-GET↗](http://10.19.12.152:8989/project/502/interface/api/34348) 的 **请求配置的类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/auditlog/list`
 * @更新时间 `2026-01-20 17:27:37`
 */
type ApiGetHxeAuditlogListRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/hxe/auditlog/list',
    'data',
    string,
    | 'sdate'
    | 'edate'
    | 'userId'
    | 'uid'
    | 'clientIp'
    | 'orderKey'
    | 'order'
    | 'index'
    | 'len'
    | 'logType',
    false
  >
>

/**
 * 接口 [操作记录-GET↗](http://10.19.12.152:8989/project/502/interface/api/34348) 的 **请求配置**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/auditlog/list`
 * @更新时间 `2026-01-20 17:27:37`
 */
const apiGetHxeAuditlogListRequestConfig: ApiGetHxeAuditlogListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: '/api/app/hxe/auditlog/list',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: [
      'sdate',
      'edate',
      'userId',
      'uid',
      'clientIp',
      'orderKey',
      'order',
      'index',
      'len',
      'logType'
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetHxeAuditlogList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [操作记录-GET↗](http://10.19.12.152:8989/project/502/interface/api/34348) 的 **请求函数**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/auditlog/list`
 * @更新时间 `2026-01-20 17:27:37`
 */
const apiGetHxeAuditlogList = /*#__PURE__*/ (
  requestData: ApiGetHxeAuditlogListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetHxeAuditlogListResponse>(
    prepare(apiGetHxeAuditlogListRequestConfig, requestData),
    ...args
  )
}

apiGetHxeAuditlogList.requestConfig = apiGetHxeAuditlogListRequestConfig

/**
 * 接口 [操作记录-GET↗](http://10.19.12.152:8989/project/502/interface/api/34348) 的 **React Hook**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/auditlog/list`
 * @更新时间 `2026-01-20 17:27:37`
 */
export const useApiGetHxeAuditlogList = /*#__PURE__*/ makeRequestHook<
  ApiGetHxeAuditlogListRequest,
  ApiGetHxeAuditlogListRequestConfig,
  ReturnType<typeof apiGetHxeAuditlogList>
>(apiGetHxeAuditlogList)

/**
 * 接口 [更新实例信息↗](http://10.19.12.152:8989/project/502/interface/api/34355) 的 **请求类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/inst/update`
 * @更新时间 `2026-01-20 17:27:37`
 */
export interface ApiPostHxeInstUpdateRequest {
  uid?: number
  type?: number
  dc?: string
  dc1?: string
  quota?: number
  quotaId?: number
  maxmemPolicy?: number
  slaveNum?: number
  isPersistence?: number
  persistenceFreq?: string
  info?: string
  envType?: number
  isDisasterRecovery?: number
  password?: string
  totalMem?: number
  usedMem?: number
  usedMemRate?: number
  freePeriod?: number
  createDatetime?: number
  creatorId?: string
  isEdit?: number
  applyId?: number
  activeFields?: string[]
  extInfo?: string
  period?: number
  version?: number
  realName?: string
  department?: string
  currentExpireDate?: number
  imageVal?: string
  imageId?: number
  groupIds?: string
  groupVal?: string
  imageName?: string
  /**
   * 集群实例持久化策略
   */
  savePeriod?: number[]
  saveTime?: string
  aliveType?: number
  /**
   * 配置变更进度
   */
  configProgress?: string
}

/**
 * 接口 [更新实例信息↗](http://10.19.12.152:8989/project/502/interface/api/34355) 的 **返回类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/inst/update`
 * @更新时间 `2026-01-20 17:27:37`
 */
export type ApiPostHxeInstUpdateResponse = string

/**
 * 接口 [更新实例信息↗](http://10.19.12.152:8989/project/502/interface/api/34355) 的 **请求配置的类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/inst/update`
 * @更新时间 `2026-01-20 17:27:37`
 */
type ApiPostHxeInstUpdateRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/hxe/inst/update',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [更新实例信息↗](http://10.19.12.152:8989/project/502/interface/api/34355) 的 **请求配置**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/inst/update`
 * @更新时间 `2026-01-20 17:27:37`
 */
const apiPostHxeInstUpdateRequestConfig: ApiPostHxeInstUpdateRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: '/api/app/hxe/inst/update',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPostHxeInstUpdate',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [更新实例信息↗](http://10.19.12.152:8989/project/502/interface/api/34355) 的 **请求函数**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/inst/update`
 * @更新时间 `2026-01-20 17:27:37`
 */
const apiPostHxeInstUpdate = /*#__PURE__*/ (
  requestData: ApiPostHxeInstUpdateRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPostHxeInstUpdateResponse>(
    prepare(apiPostHxeInstUpdateRequestConfig, requestData),
    ...args
  )
}

apiPostHxeInstUpdate.requestConfig = apiPostHxeInstUpdateRequestConfig

/**
 * 接口 [更新实例信息↗](http://10.19.12.152:8989/project/502/interface/api/34355) 的 **React Hook**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/inst/update`
 * @更新时间 `2026-01-20 17:27:37`
 */
export const useApiPostHxeInstUpdate = /*#__PURE__*/ makeRequestHook<
  ApiPostHxeInstUpdateRequest,
  ApiPostHxeInstUpdateRequestConfig,
  ReturnType<typeof apiPostHxeInstUpdate>
>(apiPostHxeInstUpdate)

/**
 * 接口 [实例详情-GET↗](http://10.19.12.152:8989/project/502/interface/api/34362) 的 **请求类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/inst/info`
 * @更新时间 `2026-01-20 17:27:36`
 */
export interface ApiGetHxeInstInfoRequest {
  uid?: string
  type?: string
  envType?: string
}

/**
 * 接口 [实例详情-GET↗](http://10.19.12.152:8989/project/502/interface/api/34362) 的 **返回类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/inst/info`
 * @更新时间 `2026-01-20 17:27:36`
 */
export interface ApiGetHxeInstInfoResponse {
  instInfo?: {
    uid?: number
    type?: number
    dc?: string
    dc1?: string
    quota?: number
    quotaId?: number
    maxmemPolicy?: number
    slaveNum?: number
    isPersistence?: number
    persistenceFreq?: string
    info?: string
    envType?: number
    isDisasterRecovery?: number
    password?: string
    totalMem?: number
    usedMem?: number
    usedMemRate?: number
    freePeriod?: number
    createDatetime?: number
    creatorId?: string
    isEdit?: number
    applyId?: number
    activeFields?: string[]
    extInfo?: string
    period?: number
    version?: number
    realName?: string
    department?: string
    currentExpireDate?: number
    imageVal?: string
    imageId?: number
    groupIds?: string
    groupVal?: string
    imageName?: string
    /**
     * 集群实例持久化策略
     */
    savePeriod?: number[]
    saveTime?: string
    aliveType?: number
    /**
     * 配置变更进度
     */
    configProgress?: string
  }
  apiUrl?: {
    apiv1?: string
    apiv2?: string
    apiInfos?: {
      role?: string
      ip?: string
      port?: number
      persistence?: number
    }[]
  }
}

/**
 * 接口 [实例详情-GET↗](http://10.19.12.152:8989/project/502/interface/api/34362) 的 **请求配置的类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/inst/info`
 * @更新时间 `2026-01-20 17:27:36`
 */
type ApiGetHxeInstInfoRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/hxe/inst/info',
    'data',
    string,
    'uid' | 'type' | 'envType',
    false
  >
>

/**
 * 接口 [实例详情-GET↗](http://10.19.12.152:8989/project/502/interface/api/34362) 的 **请求配置**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/inst/info`
 * @更新时间 `2026-01-20 17:27:36`
 */
const apiGetHxeInstInfoRequestConfig: ApiGetHxeInstInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: '/api/app/hxe/inst/info',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: ['uid', 'type', 'envType'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetHxeInstInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [实例详情-GET↗](http://10.19.12.152:8989/project/502/interface/api/34362) 的 **请求函数**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/inst/info`
 * @更新时间 `2026-01-20 17:27:36`
 */
const apiGetHxeInstInfo = /*#__PURE__*/ (
  requestData: ApiGetHxeInstInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetHxeInstInfoResponse>(
    prepare(apiGetHxeInstInfoRequestConfig, requestData),
    ...args
  )
}

apiGetHxeInstInfo.requestConfig = apiGetHxeInstInfoRequestConfig

/**
 * 接口 [实例详情-GET↗](http://10.19.12.152:8989/project/502/interface/api/34362) 的 **React Hook**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/inst/info`
 * @更新时间 `2026-01-20 17:27:36`
 */
export const useApiGetHxeInstInfo = /*#__PURE__*/ makeRequestHook<
  ApiGetHxeInstInfoRequest,
  ApiGetHxeInstInfoRequestConfig,
  ReturnType<typeof apiGetHxeInstInfo>
>(apiGetHxeInstInfo)

/**
 * 接口 [实例延期↗](http://10.19.12.152:8989/project/502/interface/api/34369) 的 **请求类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/inst/postpone`
 * @更新时间 `2026-01-20 17:27:38`
 */
export interface ApiPostHxeInstPostponeRequest {
  uid?: number
  type?: number
  envType?: number
  months?: number
  applyId?: number
}

/**
 * 接口 [实例延期↗](http://10.19.12.152:8989/project/502/interface/api/34369) 的 **返回类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/inst/postpone`
 * @更新时间 `2026-01-20 17:27:38`
 */
export type ApiPostHxeInstPostponeResponse = string

/**
 * 接口 [实例延期↗](http://10.19.12.152:8989/project/502/interface/api/34369) 的 **请求配置的类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/inst/postpone`
 * @更新时间 `2026-01-20 17:27:38`
 */
type ApiPostHxeInstPostponeRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/hxe/inst/postpone',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [实例延期↗](http://10.19.12.152:8989/project/502/interface/api/34369) 的 **请求配置**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/inst/postpone`
 * @更新时间 `2026-01-20 17:27:38`
 */
const apiPostHxeInstPostponeRequestConfig: ApiPostHxeInstPostponeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: '/api/app/hxe/inst/postpone',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPostHxeInstPostpone',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [实例延期↗](http://10.19.12.152:8989/project/502/interface/api/34369) 的 **请求函数**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/inst/postpone`
 * @更新时间 `2026-01-20 17:27:38`
 */
const apiPostHxeInstPostpone = /*#__PURE__*/ (
  requestData: ApiPostHxeInstPostponeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPostHxeInstPostponeResponse>(
    prepare(apiPostHxeInstPostponeRequestConfig, requestData),
    ...args
  )
}

apiPostHxeInstPostpone.requestConfig = apiPostHxeInstPostponeRequestConfig

/**
 * 接口 [实例延期↗](http://10.19.12.152:8989/project/502/interface/api/34369) 的 **React Hook**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `POST /api/app/hxe/inst/postpone`
 * @更新时间 `2026-01-20 17:27:38`
 */
export const useApiPostHxeInstPostpone = /*#__PURE__*/ makeRequestHook<
  ApiPostHxeInstPostponeRequest,
  ApiPostHxeInstPostponeRequestConfig,
  ReturnType<typeof apiPostHxeInstPostpone>
>(apiPostHxeInstPostpone)

/**
 * 接口 [实例列表-GET↗](http://10.19.12.152:8989/project/502/interface/api/34376) 的 **请求类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/inst/list`
 * @更新时间 `2026-01-20 17:27:36`
 */
export interface ApiGetHxeInstListRequest {
  envType?: string
  type?: string
  statId?: string
  /**
   * 用于搜索
   */
  search?: string
  searchKey?: string
  sdate?: string
  edate?: string
  index?: string
  len?: string
  orderKey?: string
  /**
   * 0-asc 1-desc
   */
  order?: string
  version?: string
  aliveType?: string
  /**
   * 分页参数
   */
  page?: string
  /**
   * 分页大小
   */
  pageSize?: string
}

/**
 * 接口 [实例列表-GET↗](http://10.19.12.152:8989/project/502/interface/api/34376) 的 **返回类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/inst/list`
 * @更新时间 `2026-01-20 17:27:36`
 */
export interface ApiGetHxeInstListResponse {
  objList?: {
    uid?: number
    password?: string
    statId?: number
    totalMem?: number
    usedMem?: number
    usedMemRate?: number
    dc?: string
    dc1?: string
    createDatetime?: number
    creatorId?: string
    isPersistence?: number
    freePeriod?: number
    currentExpireDate?: number
    info?: string
    envType?: number
    type?: number
    isEdit?: number
    realName?: string
    department?: string
    visitor?: number
    /**
     * 是否在回收站
     */
    isRecycled?: number
    quotaId?: number
    version?: number
    uids?: string
    aliveType?: number
    aliveGroupId?: number
    subInsts?: {
      uid?: number
      password?: string
      statId?: number
      totalMem?: number
      usedMem?: number
      usedMemRate?: number
      dc?: string
      dc1?: string
      createDatetime?: number
      creatorId?: string
      isPersistence?: number
      freePeriod?: number
      currentExpireDate?: number
      info?: string
      envType?: number
      type?: number
      isEdit?: number
      realName?: string
      department?: string
      visitor?: number
      /**
       * 是否在回收站
       */
      isRecycled?: number
      quotaId?: number
      version?: number
      uids?: string
      aliveType?: number
      aliveGroupId?: number
      subInsts?: {}[]
      syncState?: number
    }[]
    syncState?: number
  }[]
  totalCount?: number
}

/**
 * 接口 [实例列表-GET↗](http://10.19.12.152:8989/project/502/interface/api/34376) 的 **请求配置的类型**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/inst/list`
 * @更新时间 `2026-01-20 17:27:36`
 */
type ApiGetHxeInstListRequestConfig = Readonly<
  RequestConfig<
    'http://10.19.12.152:8989/mock/502',
    '',
    '',
    '/api/app/hxe/inst/list',
    'data',
    string,
    | 'envType'
    | 'type'
    | 'statId'
    | 'search'
    | 'searchKey'
    | 'sdate'
    | 'edate'
    | 'index'
    | 'len'
    | 'orderKey'
    | 'order'
    | 'version'
    | 'aliveType'
    | 'page'
    | 'pageSize',
    false
  >
>

/**
 * 接口 [实例列表-GET↗](http://10.19.12.152:8989/project/502/interface/api/34376) 的 **请求配置**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/inst/list`
 * @更新时间 `2026-01-20 17:27:36`
 */
const apiGetHxeInstListRequestConfig: ApiGetHxeInstListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: '/api/app/hxe/inst/list',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: [
      'envType',
      'type',
      'statId',
      'search',
      'searchKey',
      'sdate',
      'edate',
      'index',
      'len',
      'orderKey',
      'order',
      'version',
      'aliveType',
      'page',
      'pageSize'
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGetHxeInstList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {}
  }

/**
 * 接口 [实例列表-GET↗](http://10.19.12.152:8989/project/502/interface/api/34376) 的 **请求函数**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/inst/list`
 * @更新时间 `2026-01-20 17:27:36`
 */
const apiGetHxeInstList = /*#__PURE__*/ (
  requestData: ApiGetHxeInstListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGetHxeInstListResponse>(
    prepare(apiGetHxeInstListRequestConfig, requestData),
    ...args
  )
}

apiGetHxeInstList.requestConfig = apiGetHxeInstListRequestConfig

/**
 * 接口 [实例列表-GET↗](http://10.19.12.152:8989/project/502/interface/api/34376) 的 **React Hook**
 *
 * @分类 [Redis-狐小e接口↗](http://10.19.12.152:8989/project/502/interface/api/cat_5123)
 * @请求头 `GET /api/app/hxe/inst/list`
 * @更新时间 `2026-01-20 17:27:36`
 */
export const useApiGetHxeInstList = /*#__PURE__*/ makeRequestHook<
  ApiGetHxeInstListRequest,
  ApiGetHxeInstListRequestConfig,
  ReturnType<typeof apiGetHxeInstList>
>(apiGetHxeInstList)

/* prettier-ignore-end */
